<style lang="stylus">
    .library-area
        z-index 2
        user-select none
        // width: 248px;
        box-sizing border-box;
        .Library-mask
            width calc(100% - 2px);
            box-sizing border-box;
            height calc(100% - 56px)
            z-index 1
            background var(--bg-color-white)
            position absolute
            left: 0;
            top 56px
            display flex
            justify-content center
            align-items center
            .loading-box
                display flex
                justify-content center
                flex-wrap wrap
                width 100px
                img
                    width 32px
                    height 32px
                p
                    margin-top 10px
                    font-size 14px
                    color var(--text-color-primary)

        .tool-mask
            position absolute
            top 0
            left 0;
            height 56px
            width calc(100% - 2px);
            background var(--bg-color-white)
            opacity 0.6
            cursor not-allowed
            z-index 1

        .Library-error
            width calc(100% - 2px);
            height calc(100% - 144px)
            z-index 1
            background var(--bg-color-white)
            position absolute
            top 56px
            left 0;
            display flex
            flex-wrap wrap
            justify-content center
            align-content center
            .Library-errorbox
                width 136px
                height 136px
                display flex
                justify-content center
                align-content center
                flex-wrap wrap
                cursor pointer
                &:hover
                    .Library-error-icon
                        stroke var(--svg-color-gray-42)
                    .Library-error-text
                        color var(--svg-color-gray-42)

                .Library-error-icon
                    width 32px
                    height 32px
                    margin-bottom 10px
                    stroke #757575
                .Library-error-text
                    text-align center
                    width 100%
                    font-size 14px
                    color #757575

        .library-dragline
            position absolute
            top 56px
            right 0
            width 2px
            height calc(100% - 56px)
            cursor col-resize

        .my-library-title
            width 100%
            height 40px
            background-color var(--bg-color-white);
            display: flex;
            align-items center
            padding 8px 16px;
            .library-title
                cursor pointer
                display flex
                align-items center
                // &:hover{
                //   background-color: $main-hovercolor;
                // }
                >span
                    font-size 14px
                    user-select none
                    line-height 20px
                    display inline-block
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap

                .library-icon
                    width 20px
                    height 20px
            .activeFunc
                background-color var(--themeActived)
            .my-library-action
                flex: 1;
                display flex;
                align-items center;
                justify-content space-between
                .expand-tips
                    height: 26px
                    width: 26px
                    padding:0 5px;
                    border-radius: $box-radius;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position relative
                    cursor pointer
                    &:hover{
                      background-color: $main-hovercolor;
                    }
                    svg
                        width: 16px;
                        height: 16px;
                        stroke: var(--svg-color-gray-42)
                        user-select: none;
                        animation: jump 1s linear infinite;
                    @keyframes jump {
                      0% {
                        transform translateY(-5%)
                      }
                      50%{
                        transform translateY(5%)
                      }
                      100% {
                        transform translateY(-5%)
                      }
                    }
                .add-new-library
                    width: 24px;
                    height: 24px;
                    cursor pointer
                    svg
                        width: 24px;
                        height: 24px;
                        color: var(--svg-color-primary);
        .library-title
            height  40px
            display flex
            align-items center
            justify-content space-between
            &.with-aientry
                padding 0 16px
                margin-bottom 8px
            >p
                font-size 14px
                color var(--text-color-primary);
                font-weight 700
            .aientry
                display flex
                align-items center
                cursor pointer
                img
                    width 24px
                    height 24px
                p
                    font-size 12px
                    color var((--themeColor))
        .library-search
            padding 0 16px
            margin-bottom 8px
            .search-box-wrapper
                display: flex;
                height: 32px;
                // padding: 4px 4px 4px 12px;
                justify-content: flex-end;
                align-items: center;
                border-radius: 6px;
                position relative
                input
                    border: 1px solid var(--border-color-gray2);
                    flex 1
                    outline none
                    height: 32px;
                    padding: 4px 4px 4px 12px;
                    border-radius: 6px;
                    width inherit
                    background-color var(--bg-color-primary)
                    &:focus
                        border-color: var(--themeColor);
                .library-clear
                    position: absolute
                    right: 28px
                    display flex;
                    align-items center
                    cursor pointer
                    width 24px;
                    height 24px;
                    svg
                        height 100%;
                        width 100%;
                        color: var(--svg-color-primary);
                .library-search-btn
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    right: 4px;
                    display flex
                    align-items center
                    justify-content center
                    border-radius: $box-radius;
                    cursor pointer
                    svg
                        height 24px;
                        width 24px;
                        color: var(--svg-color-primary)
                .step-wrapper
                    position absolute
                    width 228px
                    height 44px
                    margin -6px
                    z-index -1
                    &::before
                        content ''
                        width 100%
                        height 100%
                        display block
                        background var(--color-white)
                        border-radius 6px
                .step-wrapper.shepherd-target
                        background rgba(0,0,0,0.5)

        .library-search-loading
            padding 16px
            background var(--bg-color-library-container)
            display flex
            flex-wrap wrap
            justify-content space-between
            overflow hidden
            &.library-search-noresult
                height calc(100% - 104px)
                align-content center
            .library-search-box
                width 100%
                background var(--bg-color-library-container)
                display flex
                flex-wrap wrap
                justify-content space-between
                align-items: center;
                overflow hidden
                &.maxWidth
                    .text
                        max-width 150px
                .text
                    font-size 14px;
                    color var(--text-color-primary)
                &.library-search-searching
                    .text
                        &::after
                            content '...'
                            display inline-block
                            text-align left
                            width 13px
                            font-size 16px
                            color #333
                            animation loading 1s infinite
                            line-height 1
                .expand-search-library
                    height: 24px
                    width: 24px
                    border-radius: $box-radius;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position relative
                    cursor pointer
                    border-radius 4px;
                    &:hover{
                      background-color: $main-hovercolor;
                    }
                    svg
                        width: 24px;
                        height: 24px;
                        color: var(--svg-color-primary)
                        user-select: none;
                .library-search-img
                    width 106px
                    height 80px
                    margin 0 auto 8px auto
                .noresult-graytext
                    color var(--text-color-tertiary)
                    font-size 12px
                    line-height 16px
                    margin-bottom 12px
                    width 100%
                    text-align center
                .noresult-tips
                    width 157px
                    margin 0 auto
                    font-size 12px
                    line-height 24px
                    text-align center
                    .noresult-bluetext
                        margin 0 4px
                        color var(--themeColor)
                        cursor pointer
            .library-search-btn
                color: #fff;
                background-color: var(--themeColor);
                height: 28px;
                margin: 12px auto;
                padding: 0 12px;
                text-align: center;
                line-height: 28px;
                border-radius: 3px;
                &:hover
                    background-color var(--themeHover)

        .library-container
            height calc(100% - 144px)
            overflow-y auto
            text-align center
            background-color: var(--bg-color-library-container)
            .library-panel
                margin-bottom 4px;
                // backface-visibility: hidden;
                border 1px solid transparent;
                .library-title
                    height 40px
                    background-color var(--bg-color-white)
                    display flex
                    align-items center;
                    justify-content space-between;
                    position sticky;
                    top 0;
                    z-index 1;
                    padding 0 16px;
                    &:hover
                        .library-action
                            .library-edit-box
                                display flex;
                            .empty-edit
                                display none;
                    .library-action
                        display flex;
                        align-items center;
                        justify-content center;
                        .empty-edit
                            width: 24px;
                            height: 24px;
                            margin-right 8px;
                        .library-edit-box
                            display: none;
                            width: 24px;
                            height: 24px;
                            justify-content: center;
                            align-items: center;
                            // padding: 4px 5px 4px 4px
                            margin-right 8px;
                            // padding 3px;
                            border-radius 4px;
                            &:hover{
                                background-color: $main-hovercolor;
                            }
                            .library-del
                                height 24px;
                                width 24px;
                                cursor pointer
                                user-select none
                                color: var(--svg-color-primary)
                                // &:hover{
                                //     background-color: #f5f5f5;
                                // }
                        .library-expand
                            cursor pointer
                            height 24px
                            width 24px
                            color: var(--svg-color-primary)
                    .library-title-text
                        height 100%
                        display flex
                        align-items center
                        width: calc(100% - 56px);
                        &.searchlib-title-text
                            width: calc(100% - 54px);
                        &.moving
                            cursor move
                            >span
                                cursor move
                        >span
                            display inline-block
                            line-height initial
                            user-select none
                            cursor pointer
                            width 100%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            text-align left
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 700;
                            color: var(--text-color-primary)
                    .library-title-add
                        display flex
                        justify-content center
                        align-items center
                        width 24px
                        height 24px
                        margin-right 8px;
                        cursor pointer
                        border-radius 4px;
                        &:hover
                            background $main-hovercolor
                        svg
                            width 24px
                            height 24px
                            color: var(--svg-color-primary)
                .library-internal
                    // overflow hidden
                    // border 2px dashed transparent
                    // background-color #fefefe
                    // border-radius 3px
                    // border 1px solid #e2e2e2
                    padding 0 16px;
                    display: grid;
                    grid-gap: 6px;
                    &.highlight
                        .library-collect-block
                            background-color: var(--bg-color-themeHover);
                            border: 2px dashed var(--themeColor);
                            .library-collect-dragblock
                                svg
                                    fill: var(--svg-color-active)
                                p
                                    color: var(--themeColor)
                        .library-shape
                            pointer-events none
                    .library-shape
                        cursor: move;
                        width 48px
                        height 48px
                        border-radius: $box-radius;
                        position relative
                        background-color var(--bg-color-library-shape);
                        &.selected
                            &:hover
                                background $main-selectcolor
                        &.leftdrop
                            border-left 1px solid #000
                        &.rightdrop
                            border-right 1px solid #000
                        img
                            width 100%
                            height 100%
                            object-fit contain
                        img[lazy=loading]
                            width 100%
                            height 100%
                            object-fit cover;
                            border-radius: $box-radius;
                        .library-control
                            width 6px
                            height 6px
                            position absolute
                        .vip-point
                            width 20px
                            height 20px
                            top 0
                            right 0
                            position absolute
                            display none
                        &:hover
                            .vip-point
                                display block
                        .library-noimage
                            width 100%
                            height 100%
                            background-color var(--bg-color-white)
                            font-size $main-fontsize
                            line-height 2
                            text-align center

                        &:not(.selected):hover
                            background-color var(--bg-color-left-panel-library-shape-hover)
                    .library-shape-add
                        cursor: pointer;
                        float left
                        width 48px
                        height 48px
                        border-radius: $box-radius;
                        position relative
                        display flex;
                        align-items center
                        justify-content center
                        &:hover
                            background-color $main-hovercolor
                            .add-my-symbol
                                svg
                                    opacity 1
                        .add-my-symbol
                            width: 44px;
                            height: 44px;
                            border-radius: 6px;
                            border: 1.5px dashed var(--border-color-add-my-symbol);
                            display flex;
                            align-items center
                            justify-content center
                            svg
                                width 16px;
                                height 16px
                                color var(--svg-color-primary)
                                opacity 0.6
                    .library-search-title
                        display flex
                        align-items center
                        width 100%
                        padding-left 20px
                        color #353535
                        .library-expand
                            width 8px
                            height 8px
                            user-select none
                            margin-right 5px
                    .library-search-content
                        overflow auto
                        margin-bottom 10px

                    .library-collect-block
                        width 100%
                        display flex
                        justify-content center
                        align-items center
                        border 1.5px dashed var(--border-color-gray2)
                        border-radius: 6px;
                        .library-collect-dragblock
                            padding 16px;
                            display flex
                            justify-content center
                            align-items center
                            height 64px

                            font-size 14px
                            color #e2e2e2
                            text-align center
                            .libraty-collect-icon
                                width 16px
                                height 16px
                                margin-right 10px
                                cursor pointer
                                fill: #9E9E9E;
                            p
                                color var(--text-color-primary)
                                font-size 12px
                                font-weight 400
                                text-align center
                .library-search-show-more-result
                    margin 8px 0;
                    line-height 24px;
                    height 24px;
                    font-size 14px
                    color: var(--color-black-50);
                    cursor pointer
            .move-libs,.drag-libs
                opacity .3
            .library-noCollect
                display flex
                justify-content center
                flex-wrap wrap
                margin-top 20px
                .noCollect-text
                    width 100%
                    font-size 13px
                    text-align center
                .noCollect-btn
                    width 80px
                    height 24px
                    margin-top 20px
                    color #fff
                    line-height 24px
                    text-align center
                    background-color var(--themeColor)
                    border-radius 3px
                    cursor pointer
                    user-select none
                    transition background-color .2s linear
                    &:hover
                        background-color var(--themeHover)
            .library-collect-close
                position absolute
                width 100%
                top 45px
                left 0
                .library-del
                    width 12px
                    height 12px
                    cursor pointer
                    position absolute
                    top 3px
                    right 3px
                    user-select none




        .Library_imgbox
            position relative
            width 64px
            height 85px
            p
                margin-top -10px
                width 60px
                font-size $main-fontsize
                text-align center
                text-overflow ellipsis
                overflow hidden
                white-space nowrap



        .delShape
            position absolute
            width 35px
            height 20px
            background-color var(--bg-color-white)
            box-shadow 0 0 4px #d7d7d7
            line-height 20px
            text-align center
            z-index 999
            cursor pointer
            user-select none
        #previewIMG
            img
                width 100%
                height 100%
                object-fit contain
        .library-addshape
            position absolute
            bottom 0px;
            left 50%;
            transform translateX(-50%);
            height 56px;
            border-top 1px solid rgba(0,0,0,0.08)
            padding 12px 16px;
            background var(--bg-color-white);
            display flex;
            width 100%;
            z-index 3;
            .library-addshape-btn
                display inline-block
                flex 1
                vertical-align top
                padding 0 12px
                height 32px
                line-height 32px
                text-align center
                background-color var(--themeColor)
                font-size 13px
                color #fff
                border-radius 6px
                cursor pointer
                user-select none
                transition background-color .2s linear
                z-index 3
                &:hover
                    background-color var(--themeHover)
    .libsBox-move
        transition all .4s;
    .drag-img
        position absolute
        left 0
        top 0
        max-width 64px
        max-height 64px
        pointer-events none
        svg
            width 64px
            height 64px
        .drag-count
            position absolute
            left 9px
            bottom 0
            width 46px
            height 12px
            background #b9b9b9
            color var(--text-color-white)
            font-size 12px
            line-height 12px
            text-align center
    @keyframes loading
        0%
            content '.  '
        50%
            content '.. '
        100%
            content '...'
    // .library-thumb
    //     position: absolute;
    //     left: calc(100% + 5px);
    //     // display none;
    //     background: #fff;
    //     border: #e9edf2;
    //     box-shadow: 0 4px 10px 0 rgba(0,0,0,.1);
    //     border-radius: 4px;
    //     color: #212930;
    //     font-size: 13px;
    //     text-align: center
    //     padding 4px 2px;
    //     img
    //         width 180px;
    //         height 90px
    //         display inline-block
</style>
<template>
    <div id="Library" class="library-area">
        <div class="Library-mask" v-show="!libraryLoadedStatus">
            <div class="loading-box">
                <img :src="require('@/app/assets/loading.gif')" alt="" />
                <p>{{ $t("loading") }}</p>
            </div>
        </div>
        <div class="Library-error" v-if="libraryError">
            <div class="Library-errorbox" @click="reloadLibrary()">
                <svg
                    class="Library-error-icon"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    stroke="inherit"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M27 16C27 22.0751 22.0751 27 16 27C12.0072 27 8.92746 25.183 7 22M5 16C5 9.92487 9.92487 5 16 5C19.9928 5 23.0725 6.86869 25 10.0517M25 10.0517V6M25 10.0517H21M7 22V26M7 22H11"
                        stroke="inherit"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <p class="Library-error-text">{{ $t("loadFail") + $t("retry") }}</p>
            </div>
        </div>
        <div class="tool-mask" v-show="!libraryLoadedStatus"></div>
        <div class="library-title with-aientry" v-if="libraryType != 'myLibrary'">
            <p>{{ $t("symbol") }}</p>
            <div class="aientry" @click="showAiDraw" v-if="showAiDrawTool">
                <img src="@/app/assets/leftPanel/pixabay/ai.svg" alt="" />
                <p>{{ $t("aiSymbol") }}</p>
            </div>
        </div>
        <div class="my-library-title" id="libraryMenu" v-if="libraryType === 'myLibrary'">
            <div class="library-title" :class="{ activeFunc: activeFunc == 'showLibrary' }" v-tippy="{ content: $t('title'), placement: 'bottom' }">
                <span v-show="sceneLeft >= 220" :style="{ 'font-weight': 700, 'max-width': '110px' }">
                    {{ $t("title") }}
                </span>
            </div>
            <div class="my-library-action">
                <div
                    class="expand-tips"
                    @click="cleanExpand()"
                    v-if="expandLibIds.length > 0"
                    :content="$t('foldLib')"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <iconSymbol class="item-icon" name="DoubleUpTri" />
                </div>
                <div
                    class="expand-tips"
                    @click="allExpand()"
                    v-if="expandLibIds.length == 0"
                    :content="$t('expandLib')"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <iconSymbol class="item-icon" name="DoubleDownTri" />
                </div>
                <span class="add-new-library" :content="$t('addNewLibrary')" v-tippy="{ placement: 'bottom' }" @click.stop="handleAddNewTable()">
                    <iconSymbol class="item-icon" name="create-library" />
                </span>
            </div>
        </div>
        <div class="library-search" id="libraryMenu" v-else :style="{ width: scrollContentWidth }">
            <div class="search-box-wrapper">
                <input
                    type="text"
                    ref="libSearchInput"
                    v-model="renderLibSearchStr"
                    :placeholder="$t('searchSymbol')"
                    @keydown="cleanSearchInput()"
                    @keyup.enter="searchRenderLibs"
                />

                <div class="library-clear" @click="clearRenderLibs()" v-show="renderLibSearchStr">
                    <iconSymbol class="item-icon" name="close-library-search" />
                </div>
                <div class="library-search-btn" @click="searchRenderLibs()" :content="$t('searchSymbol')" v-tippy="{ placement: 'bottom' }">
                    <iconSymbol class="item-icon" name="library-search-new" />
                </div>
                <div class="step-wrapper" v-if="!EDCONFIG.IS_SDK"></div>
            </div>
        </div>
        <div
            class="library-search-loading"
            :class="{ 'library-search-noresult': libSearchText == 'noResult' }"
            v-show="showSearchText && libraryType === 'publicLibrary'"
            :style="{ width: scrollContentWidth }"
        >
            <div class="library-search-box" :class="{ 'library-search-searching': libSearchText == 'searchIng', maxWidth: sceneLeft <= 290 }">
                <template v-if="libSearchText == 'noResult'">
                    <img class="library-search-img" src="@/app/assets/empty-library.png" alt="" />
                    <p class="noresult-graytext">
                        {{ `${$t(EDCONFIG.IS_SDK ? "noResultSdk" : "searchNoResult", { keyword: renderLibSearchStr })}` }}
                    </p>
                    <i18n path="searchTips" tag="p" class="noresult-tips" v-if="!EDCONFIG.IS_SDK">
                        <template #store>
                            <span class="noresult-bluetext" @click="goSymbolCommu">{{ $t("store") }}</span>
                        </template>
                        <template #aiSymbol>
                            <span class="noresult-bluetext" @click="goAiSymbol">{{ $t("aiSymbol") }}</span>
                        </template>
                    </i18n>
                </template>
                <template v-else>
                    <span class="text">
                        {{ libSearchText === "searchOK" ? `${$t("searchResult")}: ${this.searchData.length}` : $t(libSearchText) }}
                    </span>

                    <span
                        class="expand-search-library"
                        @click="cleanExpand()"
                        v-if="searchExpandLibIds.length > 0 && libSearchText == 'searchOK'"
                        :content="$t('foldLib')"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon" name="expand-library" />
                    </span>
                    <span
                        class="expand-search-library"
                        @click="allExpand()"
                        v-if="searchExpandLibIds.length == 0 && libSearchText == 'searchOK'"
                        :content="$t('expandLib')"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol class="item-icon" name="unexpand-library" />
                    </span>
                </template>
            </div>
        </div>
        <ScrollView
            ref="libContainer"
            id="libraryContainer"
            class="library-container"
            :style="{ height: libContainerHeight }"
            @mouseenter.native="dragSymbolEnter($event)"
            @mouseleave.native="dragSymbolLeave($event)"
            @mousewheel.native="closeFixTips()"
        >
            <div>
                <template v-if="libPage == 'publicLib'">
                    <transition-group ref="libsList" tag="div" :name="libsTranStr" :style="{ width: scrollContentWidth }">
                        <div
                            v-for="(item, tIndex) in renderLibrary"
                            class="library-panel"
                            :class="{
                                'move-libs': opacityIndex == tIndex,
                                'drag-libs': vueDragFlag && item.id < collectTBID,
                            }"
                            :key="item.id"
                            @mouseleave="leaveImg()"
                        >
                            <div
                                class="library-title"
                                @contextmenu="showLibTitleContext($event, item.id)"
                                @mousedown.left="clickLibTitle($event, tIndex, item.id)"
                            >
                                <div class="library-title-text" :class="{ moving: moveFlag }">
                                    <span
                                        v-if="item.id === collectTBID"
                                        v-tippy="{ placement: 'bottom' }"
                                        :content="$t('collectSymbol')"
                                        v-text="$t('collectSymbol')"
                                    ></span>
                                    <span
                                        v-else
                                        v-tippy="{ placement: 'bottom' }"
                                        :content="item[lang] ? item[lang] : item.title"
                                        v-text="item[lang] ? item[lang] : item.title"
                                    ></span>
                                </div>
                                <div class="library-action" :style="{ width: libraryType === 'myLibrary' ? '56px' : 'auto' }">
                                    <div class="empty-edit" v-if="libPage === 'searchLib' || libraryType === 'myLibrary'"></div>
                                    <div
                                        class="library-edit-box"
                                        @mousedown.left.stop="() => editSelfLibrary(item)"
                                        v-if="item.id >= collectTBID"
                                        :content="$t('editLib')"
                                        v-tippy="{ placement: 'bottom-start' }"
                                    >
                                        <iconSymbol class="library-del library-edit" name="edit-library" />
                                    </div>
                                    <iconSymbol class="library-expand" :name="expanded(item.id) ? 'library-arrow-up' : 'library-arrow-down'" />
                                </div>
                            </div>
                            <collapseTransition>
                                <div
                                    class="library-internal"
                                    :class="{ highlight: dragTBID == item.id && vueDragFlag }"
                                    :style="item.id >= collectTBID && item.data.length == 0 ? {} : libraryInternalStyle"
                                    v-show="expanded(item.id)"
                                    @mouseenter="libsEnter(item.id, item.title)"
                                    @mouseleave="libsLeave()"
                                >
                                    <div
                                        v-for="(img, index) in item.data"
                                        :key="index"
                                        class="library-shape"
                                        :class="{
                                            selected: editLibrayID == item.id && selectSymbolList.includes(img.table_index),
                                            leftdrop:
                                                editLibrayID == item.id &&
                                                activeLibaryID == editLibrayID &&
                                                activeLibaryID >= collectTBID &&
                                                index == activeImgIndex &&
                                                dragDirect == 0,
                                            rightdrop:
                                                editLibrayID == item.id &&
                                                activeLibaryID == editLibrayID &&
                                                activeLibaryID >= collectTBID &&
                                                index == activeImgIndex &&
                                                dragDirect == 1,
                                        }"
                                        @contextmenu="showLibContentContext($event, item.id, index)"
                                        @click.prevent="dbClickImg($event, img.shape, img.name, img[`${lang}_name`], item.id)"
                                        @mouseenter="enterImg(item.id, index, img, $event)"
                                        @mousedown="
                                            selectImg(
                                                $event,
                                                img.shape,
                                                img.name,
                                                img[`${lang}_name`],
                                                index,
                                                item.id,
                                                item[lang] ? item[lang] : item.title,
                                                img.table_index
                                            )
                                        "
                                    >
                                        <iconSymbol class="library-control" v-if="img.hasControl && vip" name="library-control" />
                                        <iconSymbol
                                            class="vip-point"
                                            v-if="!vip && (limitTableIds.includes(item.id) || img.isVip)"
                                            :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                        />
                                        <img
                                            v-if="img.url"
                                            v-lazy="img.url"
                                            draggable="false"
                                            @dragstart.prevent
                                            v-tippy="{ placement: 'bottom' }"
                                            :content="img[`${lang}_name`] ? img[`${lang}_name`] : img.name"
                                        />
                                        <div v-else class="library-noimage">no image</div>
                                    </div>
                                    <div class="library-shape-add" v-if="item.id >= collectTBID && item.data.length > 0">
                                        <div class="add-my-symbol" @click="handleImportSymlbol(item.id)">
                                            <!-- <img :src="require('')" /> -->
                                            <!-- <span></span> -->
                                            <iconSymbol name="add-my-symbol" />
                                        </div>
                                    </div>
                                    <div class="library-collect-block" v-if="item.id >= collectTBID && item.data.length == 0">
                                        <div class="library-collect-dragblock">
                                            <iconSymbol
                                                class="libraty-collect-icon"
                                                name="library-dragHere"
                                                @click.left.native.stop="handleImportSymlbol(item.id)"
                                            />
                                            <p>{{ $t("dragHere") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </collapseTransition>
                        </div>
                    </transition-group>
                </template>

                <template v-if="libPage == 'searchLib'">
                    <div v-for="(item, kIndex) in searchData" class="library-panel" :key="kIndex">
                        <div
                            class="library-title"
                            :class="{ 'library-title-active': searchExpandLibIds.includes(item.id) }"
                            @click="toggleSearchExpand(item.id)"
                        >
                            <div class="library-title-text searchlib-title-text" :title="tranGroupName(item.groupName, item.tableName)">
                                <span v-text="tranGroupName(item.groupName, item.tableName)"></span>
                            </div>
                            <div class="library-action">
                                <template>
                                    <div
                                        class="library-title-add"
                                        v-if="!activeRenderList.includes(item.tableId)"
                                        :title="$t('addSearchResultToRender')"
                                        :content="$t('addSearchResultToRender')"
                                        v-tippy="{ placement: 'bottom' }"
                                        @click.left.stop="addSearchResultToList(item)"
                                    >
                                        <iconSymbol class="add-library" name="add-library" />
                                    </div>
                                    <div
                                        class="library-title-add"
                                        v-if="activeRenderList.includes(item.tableId)"
                                        :title="$t('deleteFromSearchResult')"
                                        :content="$t('deleteFromSearchResult')"
                                        v-tippy="{ placement: 'bottom' }"
                                        @click.left.stop="deleteFromSearchResult(item)"
                                    >
                                        <iconSymbol class="unshow-library" name="unshow-library" />
                                    </div>
                                </template>
                                <iconSymbol
                                    class="library-expand"
                                    :name="searchExpandLibIds.includes(item.id) ? 'library-arrow-up' : 'library-arrow-down'"
                                />
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="library-internal" v-show="searchExpandLibIds.includes(item.id)" :style="libraryInternalStyle">
                                <div
                                    v-for="(img, index) in item.renderData"
                                    :key="index"
                                    class="library-shape"
                                    :class="{
                                        selected: editLibrayID == item.id && selectSymbolList.includes(img.table_index),
                                    }"
                                    @click.prevent="dbClickImg($event, img.shape, img.imgname, img[lang], item.id)"
                                    @contextmenu="showSearchLibContentContext($event, item.id, index)"
                                    @mousedown="
                                        selectImg(
                                            $event,
                                            img.shape,
                                            img.imgname,
                                            img[lang],
                                            index,
                                            item.id,
                                            tranGroupName(item.groupName, item.tableName),
                                            img.table_index
                                        )
                                    "
                                >
                                    <iconSymbol class="library-control" v-if="img.hasControl && vip" name="library-control" />
                                    <iconSymbol
                                        class="vip-point"
                                        v-if="!vip && limitTableIds.includes(item.id)"
                                        :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                    />
                                    <img
                                        v-if="img.url"
                                        v-lazy="img.url"
                                        draggable="false"
                                        @dragstart.prevent
                                        :title="img[lang] ? img[lang] : img.imgname"
                                    />
                                    <div v-else class="library-noimage">no image</div>
                                </div>
                            </div>
                        </transition>
                        <div
                            v-if="item.showMore && searchExpandLibIds.includes(item.tableId)"
                            class="library-search-show-more-result"
                            @click="handleShowMore(item)"
                        >
                            {{ item.data.length - 8 }}+ {{ $t("more") }}
                        </div>
                    </div>
                </template>
            </div>
        </ScrollView>
        <div class="library-dragline" @mousedown="dragLine($event)"></div>
        <div ref="dragImg" class="drag-img" v-show="showDragPreview">
            <iconSymbol name="library-dragPrview" />
            <p class="drag-count" v-show="showDragNum">{{ dragNum }}</p>
        </div>
        <div class="library-addshape" v-if="libPage == 'publicLib' && $store.state.ui.libraryLoadedStatus == 2 && libraryType === 'publicLibrary'">
            <div class="library-addshape-btn" @click="showModel('button')">
                {{ $t("addMoreShape") }}
            </div>
        </div>
        <EDNotice
            v-if="useFixTips"
            :show="showFixTips"
            :dom="fixTipsDom"
            :content="tipText"
            showBtn="true"
            forceDirect="left"
            :picPath="require('@/public/img/task/controlShape.gif')"
            @closeTips="closeFixTips"
            style="width: 267px"
        />
        <!-- <div class="library-thumb" :style="{display: libraryThumb.show ? 'block' : 'none', top: libraryThumb.top}">
            <img :src="libraryThumb.src" alt="">
            <div>{{ libraryThumb.name }}</div>
        </div> -->
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Emit, Vue, Watch, Inject } from "vue-property-decorator";
    import EDNotice from "@/app/components/Notice/EDNotice.vue";
    import appConfig from "@/public/globalConfig";
    import collapseTransition from "@/public/utils/collapse-transition.js";
    import omit from "lodash/omit";
    import { InternalLimitTableIds, OverseaLimitTableIds, LangKeys } from "@/app/utils/constant";
    import { EDRAWMAX_USE_CUSTOMLIBRARY } from "@/env/";
    import { SearchLibraryData, RenderLibraryData, LibraryItem } from "@/app/types";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import throttle from "lodash.throttle";

    @Component({
        components: {
            collapseTransition,
            EDNotice,
            ScrollView,
        },
    })
    export default class Library extends Vue {
        @Inject()
        ["showMessage"];

        libraryWorkerURL: string = appConfig.libraryWorkerURL;
        userWorkerURL: string = appConfig.userWorkerURL;
        worker: any;
        renderLibSearchStr: string = "";
        currentShapeIndex: number = -1;
        searchData: Array<SearchLibraryData> = [];
        searchBlock: boolean = false;
        libContainerHeight: string = "calc(100% - 144px)"; // searchIng searchOK - 106 noresult - 194
        libSearchText: string = "";
        showSearchText: boolean = false;

        expandLibIds: Array<number> = []; //expand library ids.
        searchExpandLibIds: Array<number> = [];
        renderGroup: object = {};
        syncSucc: string = "";
        addSuccess: string = "";
        syncFail: string = "";
        uploadCustomLibDelay: number = 0;
        uploadCollectLibDelay: number = 0;
        scrollToBottom: number = 0;
        scrollTimer: number = 0;
        searchWorker: any;
        opacityIndex: number = -1; // 拖拽库时透明显示
        libsTranStr: string = "";
        addCount: number = 0; // 需要增加的总数
        delCount: number = 0; // 需要删除的总数
        addedcount: number = 0; // 增加完成的计数
        deledcount: number = 0; // 删除完成的计数
        customLibsQueue: Array<any> = []; // 储存需要上传的库
        dragTBID: number = -1;
        dragTBName: string;
        mutiselTBID: number = -1;
        mutiselTBName: string;
        dragPromiseLimit: number = 30; // promise 数组最大长度
        dragImgPromise: Array<any> = []; // 储存生成预览图的promise
        dragImgPromiseDone: Array<any> = []; // 储存生成预览图的promise
        dragImgPromiseIndex: number = 0; // 总次数
        dragImgPromisePos: number = 0; // 实际指针位置
        showDragPreview: boolean = false;
        showDragNum: boolean = false;
        dragNum: string = "";
        isShowMessage: boolean = false;

        dragFlag: boolean = false; // 符号库自身符号拖拽
        dragDirect: number = 0; // 0 | 1  前 | 后
        activeLibaryID: number = -1;
        activeImgIndex: number = -1;
        selectSymbolList: Array<number> = [];
        editLibrayID: number = -1;

        lockExpand: boolean = false; //限制符号库展开，10s后解除

        mouseMoveBack: boolean = false; // 判断是否移入画布后再移回符号库

        moveFlag = false;

        loadFromCache = false;

        cacheLibraryOrder = {};

        // libraryThumb = {
        //     top: '200px',
        //     src: '',
        //     name: '',
        //     show: false,
        // }
        // scrollContentWidth = 248;

        get trackKey() {
            return this.libraryType === "publicLibrary" ? "shapes" : "mylibrary";
        }

        get scrollContentWidth() {
            if (!this.focusModeExpandLeft) return 0;
        }

        get libraryType() {
            return this.$store.state.library.libraryType;
        }

        get libraryInternalStyle() {
            let width = this.sceneLeft - 48 - 2 - 32;
            // 48 * n + gap * (n - 1) <= width
            let baseGap = 8;
            let repeat = Math.floor((width + baseGap) / (48 + baseGap));
            return {
                gridTemplateColumns: `repeat(${repeat}, 1fr)`,
            };
        }

        get addShapeStyle() {
            let ratio = 216 / 250;
            let parentW = this.sceneLeft - 48;
            return {
                width: `${parentW * ratio}px`,
            };
        }
        get useCustomLib() {
            return EDRAWMAX_USE_CUSTOMLIBRARY;
        }

        get renderLibrary() {
            let myLibraryData = this.$store.state.library.myLibraryData;
            let publicLibraryData = this.$store.state.library.publicLibraryData;
            let result = this.libraryType === "myLibrary" ? myLibraryData : publicLibraryData;
            return result as Array<RenderLibraryData>;
        }

        get allRenderLibraryData() {
            let myLibraryData = this.$store.state.library.myLibraryData;
            let publicLibraryData = this.$store.state.library.publicLibraryData;
            return myLibraryData.concat(publicLibraryData);
        }

        get showAiDrawTool() {
            return window.EDCONFIG.AI.ENABLE && window.EDCONFIG.AI.DRAW_ENABLE;
        }

        handleImportSymlbol(tableId: number) {
            this.$store.commit("setLibraryState", {
                type: "showImportModal",
                data: true,
            });
            this.getDbAndTableName(tableId);
        }
        handleAddNewTable() {
            if (this.checkCloudSpaceLimit()) return;
            this.$track("menu", "symbol", "NewLibrary");
            this.showDialog("AddLibrary");
        }
        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        editSelfLibrary(data) {
            this.$store.commit("setLibraryState", {
                type: "editLibrary",
                data,
            });
            this.$store.commit("setLibraryState", {
                type: "showEditModal",
                data: true,
            });
        }
        // Tool function
        difArr(arr1, arr2) {
            // 求数组差集
            let a = new Set(arr1);
            let b = new Set(arr2);
            return Array.from(new Set([...a].filter((x) => !b.has(x))));
        }
        dragLine(e) {
            window["_view"]._tool.endEdit();
            // 最小 三列  214 + 48 = 262
            // 最大 六列  362 + 48 = 410
            let x = e.pageX;
            let baseWidth = this.sceneLeft;
            document.onmousemove = (ev) => {
                let movex = baseWidth + ev.pageX - x;
                this.sceneLeft = movex < 262 ? 262 : movex > 410 ? 410 : movex;
                window["_view"].onsize();
                window["_view"].scroll();
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }

        getDbAndTableName(ID) {
            // 存储选中的库和表名
            let userInfo = this.userInfo;
            let num = 0;
            for (let i = 0; i < this.renderLibrary.length; i++) {
                if (this.renderLibrary[i]["id"] == ID) {
                    num = i;
                }
            }
            let db = this.renderLibrary[num]["group"];
            let table = this.renderLibrary[num]["title"];
            this.$store.commit("setStatus", {
                type: "selectLibrary",
                data: [db, table, ID],
            });
            this.$store.commit("setLibraryState", {
                type: "selectLibraryTitlePos",
                data: [num, this.renderLibrary.length - 1],
            });
            this.$store.commit("setLibraryState", {
                type: "symbolCount",
                data: this.renderLibrary[num]["data"].length,
            });
        }
        showLibTitleContext(e: MouseEvent, ID: number) {
            this.$store.commit("setStatus", {
                type: "contextPos",
                data: [e.pageX, e.pageY],
            });
            this.$store.commit("setStatus", {
                type: "activeContextType",
                data: this.$store.state.ui.contextType.libTitle,
            });
            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: true,
            });
            this.$store.commit("setStatus", {
                // 设置移动目标周围的id
                type: "libClickObj",
                data: {
                    preItem: -1,
                    nowItem: -1,
                    nextItem: -1,
                    clickIndex: -1,
                },
            });
            this.getDbAndTableName(ID);
            window["_view"]._tool.endEdit();
        }
        showLibContentContext(e: MouseEvent, ID: number, clickIndex: number) {
            // mac左键+control
            if (/macintosh|mac os x/i.test(navigator.userAgent) && e.ctrlKey) {
                return;
            }
            if (this.contextLocker) {
                return;
            }
            let currentLibrary = this.renderLibrary.find((v) => v.id === ID);
            let { data } = currentLibrary;
            let current = data[clickIndex];
            let pre = data[clickIndex - 1];
            let next = data[clickIndex + 1];

            this.checkMove(data.length - 1, clickIndex);
            let idObj = {
                preItem: -1,
                nowItem: current.table_index,
                nextItem: -1,
                clickIndex: clickIndex,
            };
            if (pre) {
                idObj.preItem = pre.table_index;
            }
            if (next) {
                idObj.nextItem = next.table_index;
            }

            let selectName = current[this.lang] || current.name;

            this.$store.commit("setStatus", {
                // 选中的符号信息
                type: "selectLibraryShape",
                data: {
                    name: selectName,
                    langName: current[`${this.lang}_name`],
                    shape: current.shape,
                    blob: current.blob,
                    tableID: current.table_id,
                },
            });
            this.$store.commit("setStatus", {
                // 设置移动目标周围的id
                type: "libClickObj",
                data: idObj,
            });
            this.$store.commit("setStatus", {
                type: "contextPos",
                data: [e.pageX, e.pageY],
            });
            this.$store.commit("setStatus", {
                type: "activeContextType",
                data: this.$store.state.ui.contextType.libContent,
            });
            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: true,
            });
            this.getDbAndTableName(ID);
            window["_view"]._tool.endEdit();
            if (!this.selectSymbolList.includes(clickIndex)) {
                this.cleanSymbolID();
            }
            this.getSymbolID(current.table_id, clickIndex, e.ctrlKey); // 选中shape
        }
        showSearchLibContentContext(e: MouseEvent, ID: number, clickIndex: number) {
            // mac左键+control
            if (/macintosh|mac os x/i.test(navigator.userAgent) && e.ctrlKey) {
                return;
            }
            if (this.contextLocker) {
                return;
            }
            let targetLibrary = this.searchData;
            let num = 0;
            for (let i = 0; i < targetLibrary.length; i++) {
                if (targetLibrary[i]["id"] == ID) {
                    num = i;
                }
            }
            let currentLibrary = this.searchData.find((v) => v.id === ID);
            let { data, groupName, tableName } = currentLibrary;
            let current = data[clickIndex];

            let selectName = current[this.lang] || current.imgname;

            this.$store.commit("setStatus", {
                // 选中的符号信息
                type: "selectLibraryShape",
                data: {
                    name: selectName,
                    langName: current[this.lang],
                    shape: current.shape,
                    blob: current.blob,
                    tableID: current.table_id,
                },
            });
            this.$store.commit("setStatus", {
                // 设置移动目标周围的id
                type: "libClickObj",
                data: {
                    preItem: -1,
                    nowItem: current.table_index,
                    nextItem: -1,
                    clickIndex: clickIndex,
                    ID,
                },
            });
            this.$store.commit("setStatus", {
                type: "contextPos",
                data: [e.pageX, e.pageY],
            });
            this.$store.commit("setStatus", {
                type: "activeContextType",
                data: this.$store.state.ui.contextType.libContent,
            });
            this.$store.commit("setStatus", {
                type: "showContextMenu",
                data: true,
            });
            this.$store.commit("setStatus", {
                type: "selectLibrary",
                data: [groupName, tableName, current.table_id],
            });
            window["_view"]._tool.endEdit();
            if (!this.selectSymbolList.includes(clickIndex)) {
                this.cleanSymbolID();
            }
            this.getSymbolID(ID, clickIndex, e.ctrlKey); // 选中shape
        }
        checkMove(length, clickIndex) {
            // 检查是否可以上下移动库元素
            this.$store.commit("setStatus", {
                type: "canMoveUpSymbol",
                data: true,
            });
            this.$store.commit("setStatus", {
                type: "canMoveDownSymbol",
                data: true,
            });
            if (clickIndex == 0) {
                // 点击第一个元素，禁止上移
                this.$store.commit("setStatus", {
                    type: "canMoveUpSymbol",
                    data: false,
                });
            }
            if (clickIndex == length) {
                // 点击最后一个元素，禁止下移
                this.$store.commit("setStatus", {
                    type: "canMoveDownSymbol",
                    data: false,
                });
            }
        }
        toggleExpand(id: number, i: number) {
            let index = this.expandLibIds.indexOf(id);
            if (index === -1) {
                this.expandLibIds.push(id);
            } else {
                this.expandLibIds.splice(index, 1);
            }
            window["_view"]._tool.endEdit();
            setTimeout(() => {
                if (i === this.renderLibrary.length - 1) return;
                let nextItem = this.renderLibrary[i + 1];
                if (!this.expandLibIds.includes(id) && this.expandLibIds.includes(nextItem.id)) {
                    let wrapper = (this.$refs.libContainer as Vue).$el as HTMLElement;
                    let parentScrollTop = wrapper.scrollTop;
                    if (parentScrollTop > 0) {
                        wrapper.scrollTop -= parentScrollTop - (i + 1) * 40;
                    }
                }
            }, 100);
        }
        cleanExpand() {
            this.$track("library", "folder libs");
            if (this.libPage == "searchLib") {
                this.searchExpandLibIds = [];
            } else {
                this.expandLibIds = [];
            }
        }
        allExpand() {
            this.$track("library", "expand libs");
            if (this.libPage == "searchLib") {
                this.searchExpandLibIds = this.searchData.map((v, k) => {
                    return v["id"];
                });
            } else {
                this.expandLibIds = this.renderLibrary.map((v, k) => {
                    return v["id"];
                });
            }
        }
        toggleSearchExpand(id: number) {
            let index = this.searchExpandLibIds.indexOf(id);
            if (index === -1) {
                this.searchExpandLibIds.push(id);
            } else {
                this.searchExpandLibIds.splice(index, 1);
            }
            this.closeFixTips();
        }
        libTitleIcon(id: number) {
            if (this.expanded(id)) {
                return "DownTri";
            } else {
                return "RightTri";
            }
        }
        searchTitleIcon(id: number) {
            if (this.searchExpandLibIds.includes(id)) {
                return "DownTri";
            } else {
                return "RightTri";
            }
        }
        expanded(id: number) {
            return this.expandLibIds.indexOf(id) !== -1;
        }

        @Watch("renderLibSearchStr")
        watchSearchStr(val, oldVal) {
            if (!val && this.libPage === "searchLib") {
                this.libPage = "publicLib";
                this.showSearchText = false;
                this.libSearchText = "";
                this.searchData = [];
                this.setSearchText(144, "");
            }
        }

        @Watch("libraryType")
        watchLibraryType(val, oldVal) {
            if (val === "myLibrary" && this.libPage === "searchLib") {
                this.libPage = "publicLib";
            } else if (val === "publicLibrary" && this.libPage === "publicLib" && this.renderLibSearchStr) {
                this.libPage = "searchLib";
            }
            this.libContainerHeight = val === "myLibrary" ? "calc(100% - 56px)" : "calc(100% - 144px)";
            (this.$refs.libContainer as any).update();
        }

        cleanSearchInput() {
            this.setSearchText(144, "");
        }
        setSearchText(num, state) {
            this.libContainerHeight = `calc(100% - ${num}px)`;
            this.libSearchText = state;
            if (num == 144) {
                this.showSearchText = false;
            } else if (num == 113 || num === 194 || num == 160) {
                this.showSearchText = true;
                if (num === 194) {
                    this.libContainerHeight = "0px";
                }
            }
        }
        clearRenderLibs() {
            let name = this.renderLibSearchStr.trim();
            // if (!name) {
            //     return;
            // }
            this.renderLibSearchStr = "";
        }
        searchRenderLibs() {
            let name = this.renderLibSearchStr.trim();
            if (this.searchWorker && name) {
                this.searchWorker.postMessage({
                    type: "breakSearch",
                    urls: this.urls,
                });
                this.searchWorker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type == "searchOver") {
                        this.searchWorker.terminate();
                    }
                };
            }
            if (!name) {
                this.searchBlock = false;
                return;
            }
            this.libPage = "searchLib";
            this.setSearchText(160, "searchIng");
            window["_view"]._tool.endEdit();
            this.searchData = [];
            this.searchExpandLibIds = [];
            this.$track("library", "search symbol", name);
            this.$edApi
                .searchLibraryIcon({
                    w: name,
                    lang: this.lang,
                })
                .then((e) => {
                    this.sensors.track("searchSymbolResult", {
                        Catalogues: "editFileProcess",
                        search_words: name,
                        search_class: "shapes",
                        is_find_symbol: e.data.length > 0 ? "findSomething" : "noResult",
                        search_source: "leftsidebar",
                    });
                    this.searchWorker = new Worker(this.libraryWorkerURL);
                    this.searchWorker.postMessage({
                        type: "searchFromWeb",
                        key: name,
                        lang: this.lang,
                        urls: this.urls,
                        arr: e.data,
                        host: window["GLOBAL"].PUBLIC_OSS_HOST,
                        menuList: this.menuList,
                    });
                    this.searchWorker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type == "searchOK") {
                            let data = message.data;
                            data.data.forEach((v, k) => {
                                if (v.url && Object.prototype.toString.call(v.url) === "[object Blob]") {
                                    v.url = URL.createObjectURL(v.url);
                                    v.hasControl = this.hasControlData(v.shape);
                                }
                            });
                            data.id = data.tableId;
                            this.searchExpandLibIds.push(data.id);
                            this.searchData[data.position] = data;
                            this.searchData = this.searchData.filter(Boolean);
                            data.showMore = data.data.length > 8;
                            data.renderData = data.data.slice(0, 8);
                            this.searchData = this.searchData.filter(Boolean);
                        } else if (message.type == "searchOver") {
                            this.searchWorker.terminate();
                            if (this.searchData.length == 0) {
                                this.setSearchText(194, "noResult");
                            } else {
                                this.setSearchText(160, "searchOK");
                            }
                        }
                    };
                })
                .catch((e) => {
                    this.setSearchText(194, "noResult");
                    this.searchBlock = false;
                });
        }

        handleShowMore(item) {
            item.showMore = false;
            item.renderData = item.data;
            this.searchData.splice(item.position, 1, item);
        }
        /**选择图片 */
        mouseUpEvent() {
            // 特殊处理iframe遮挡document丢失问题
            this.removeImg();
            document.onmousemove = null;
            document.onmouseup = null;
        }
        enterImg(id, index, img, e) {
            const { url, hasControl } = img;
            // this.libraryThumb.show = true;
            // this.libraryThumb.src = img.url;
            // this.libraryThumb.name = img[`${this.lang}_name`] || img.name;

            if (!this.dragFlag) {
                if (hasControl) this.checkFixTips(e.target);
                return;
            }
            this.activeLibaryID = id;
            this.activeImgIndex = index;
        }
        // handleLeaveImg() {
        //     this.libraryThumb.show = false;
        // }
        leaveImg() {
            this.activeLibaryID = -1;
            this.activeImgIndex = -1;
        }
        selectAllSymbol(tableID) {
            let num = 0;
            let targetLibrary = this.libPage == "searchLib" ? this.searchData : this.renderLibrary;
            for (let i = 0; i < targetLibrary.length; i++) {
                if (targetLibrary[i]["id"] == tableID) {
                    num = i;
                }
            }
            let data = targetLibrary[num]["data"];
            this.selectSymbolList.splice(0, this.selectSymbolList.length);
            this.editLibrayID = tableID;
            for (let i = 0; i < data.length; i++) {
                this.selectSymbolList.push(data[i]["table_index"]);
            }
            if (this.selectSymbolList.length > 1) {
                this.$store.commit("setLibraryState", {
                    type: "mutiSelect",
                    data: true,
                });
            } else {
                this.$store.commit("setLibraryState", {
                    type: "mutiSelect",
                    data: false,
                });
            }
            this.expanded(tableID) || this.expandLibIds.push(tableID);
        }
        publishLibrary(tableID) {
            let num = 0;
            let targetLibrary = this.libPage == "searchLib" ? this.searchData : this.renderLibrary;
            for (let i = 0; i < targetLibrary.length; i++) {
                if (targetLibrary[i]["id"] == tableID) {
                    num = i;
                }
            }
            let data = targetLibrary[num]["data"],
                db = targetLibrary[num]["group"],
                tb = targetLibrary[num]["title"];
            this.$store.commit("setStatus", {
                type: "showPublishSymbol",
                data: true,
            });
            this.$nextTick(() => {
                this.$bus.$emit("publishSymbolInfo", {
                    data,
                    db,
                    tb,
                    tableID,
                });
            });
            // window['_view'].saveLibrayAsPreview(data, db, tb).then(e => {
            //     console.log(e)
            // });
        }
        getSymbolID(libID, index, isCtrl) {
            this.editLibrayID = libID;
            let targetLibrary = this.libPage == "searchLib" ? this.searchData : this.renderLibrary;
            let num = 0;
            for (let i = 0; i < targetLibrary.length; i++) {
                if (targetLibrary[i] && targetLibrary[i]["id"] == libID) {
                    num = i;
                }
            }
            let symbolId = targetLibrary[num]["data"][index]["table_index"];
            if (!this.selectSymbolList.includes(symbolId)) {
                this.selectSymbolList.push(symbolId);
            } else if (isCtrl) {
                this.selectSymbolList.splice(this.selectSymbolList.indexOf(symbolId), 1);
            }
            if (this.selectSymbolList.length > 1) {
                this.$store.commit("setLibraryState", {
                    type: "mutiSelect",
                    data: true,
                });
            } else {
                this.$store.commit("setLibraryState", {
                    type: "mutiSelect",
                    data: false,
                });
            }
        }
        cleanSymbolID(e = null) {
            if (!e || !e.ctrlKey) {
                this.selectSymbolList.splice(0, this.selectSymbolList.length);
                this.$store.commit("setLibraryState", {
                    type: "mutiSelect",
                    data: false,
                });
                this.leaveImg();
            }
        }
        dropImg() {
            // 移动符号到指定位置后一位
            if (
                this.activeLibaryID == -1 ||
                this.activeImgIndex == -1 ||
                this.selectSymbolList.length == 0 ||
                this.activeLibaryID < this.collectTBID ||
                this.libPage == "searchLib" ||
                this.editLibrayID != this.activeLibaryID
            )
                return;
            let num = 0,
                addIndex = this.activeImgIndex,
                dbName = "",
                tableName = "",
                tableID = 0;
            for (let i = 0; i < this.renderLibrary.length; i++) {
                if (this.renderLibrary[i]["id"] == this.activeLibaryID) {
                    num = i;
                    dbName = this.renderLibrary[i]["group"];
                    tableName = this.renderLibrary[i]["title"];
                    tableID = this.renderLibrary[i]["id"];
                }
            }
            let temp = this.renderLibrary[num]["data"].map((item) => {
                return Object.assign({}, item);
            });
            addIndex = temp[this.activeImgIndex]["table_index"]; // 记录目标符号唯一标志
            let clipSymbol = [];
            for (let j = 0; j < this.selectSymbolList.length; j++) {
                // 先循环select保证选择顺序
                for (let i = temp.length - 1; i >= 0; i--) {
                    if (temp[i].table_index == this.selectSymbolList[j]) {
                        clipSymbol.push(temp[i]);
                        temp.splice(i, 1);
                    }
                }
            }
            // 根据记录的标志找到数组改变后的index位置
            for (let i = 0; i < temp.length; i++) {
                if (temp[i]["table_index"] == addIndex) {
                    addIndex = i;
                    break;
                }
            }
            for (let i = 0; i < clipSymbol.length; i++) {
                if (this.dragDirect) {
                    // 放置于符号前
                    temp.splice(++addIndex, 0, clipSymbol[i]);
                } else {
                    // 放置于符号后
                    temp.splice(addIndex++, 0, clipSymbol[i]);
                }
            }
            let list = temp.map((item, i) => {
                return {
                    ...omit(item, ["url", "shape", "table_id", "table_index", "tempIMG"]),
                    data: item.shape,
                    parent: tableName,
                    index: i,
                    next: temp.length - 1 == i ? null : i + 1,
                };
            });
            this.updateToDB(dbName, tableName, tableID, list);
        }
        deleteSymbol() {
            let tableID = this.dbAndTable[2];
            if (this.selectSymbolList.length == 0 || tableID < this.collectTBID || this.libPage == "searchLib") return;
            let num = 0,
                dbName = "",
                tableName = "";
            for (let i = 0; i < this.renderLibrary.length; i++) {
                if (this.renderLibrary[i]["id"] == tableID) {
                    num = i;
                    dbName = this.renderLibrary[i]["group"];
                    tableName = this.renderLibrary[i]["title"];
                }
            }

            let temp = this.renderLibrary[num]["data"].map((item) => {
                return Object.assign({}, item);
            });
            for (let j = 0; j < this.selectSymbolList.length; j++) {
                for (let i = temp.length - 1; i >= 0; i--) {
                    if (temp[i].table_index == this.selectSymbolList[j]) {
                        temp.splice(i, 1);
                    }
                }
            }

            let list = temp.map((item, i) => {
                return {
                    ...omit(item, ["url", "shape", "table_id", "table_index", "tempIMG"]),
                    data: item.shape,
                    parent: tableName,
                    index: i,
                    next: temp.length - 1 == i ? null : i + 1,
                };
            });
            this.updateToDB(dbName, tableName, tableID, list);
            this.cleanSymbolID();
        }
        mutiAddShape(obj) {
            let { DBName, tableName, tableID, isShowMessage = false } = obj;
            let num = 0;
            let view = window["_view"];
            for (let i = 0; i < this.renderLibrary.length; i++) {
                if (this.renderLibrary[i]["id"] == this.editLibrayID) {
                    num = i;
                }
            }

            let temp = this.renderLibrary[num]["data"].map((item) => {
                return Object.assign({}, item);
            });
            let list = [];
            for (let j = 0; j < this.selectSymbolList.length; j++) {
                for (let i = temp.length - 1; i >= 0; i--) {
                    if (temp[i].table_index == this.selectSymbolList[j]) {
                        list.push(temp[i]);
                    }
                }
            }

            list = list.map((item, i) => {
                return {
                    ...omit(item, ["url", "shape", "table_id", "table_index", "tempIMG"]),
                    data: view.addFromLibId(item.shape, this.editLibrayID),
                    parent: tableName,
                    index: i,
                    next: i == list.length - 1 ? null : i + 1,
                };
            });
            this.addSymbolsToDB(DBName, tableName, tableID, list, isShowMessage).then(() => {
                this.contextLocker = false;
            });
        }
        updateToDB(dbName, tableName, tableID, insertData) {
            let updateData = {
                DBName: dbName,
                tableName: tableName,
                tableID: tableID,
                insertData: insertData,
                versionDB: `myDBVersion_${this.userInfo.user_id}`,
            };
            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "removeAndUpdateTable",
                urls: this.urls,
                data: updateData,
            });

            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "updateOK") {
                    this.updateTable(dbName, tableID);
                    this.uploadLibToCloud(message).then((e: any) => {
                        let version = e.data.version;
                        this.worker.postMessage({
                            type: "setVersion",
                            urls: this.urls,
                            data: {
                                versionDB: `myDBVersion_${this.userInfo.user_id}`,
                                tableID: tableID,
                                version,
                                params: {
                                    updateModified: true,
                                },
                            },
                        });
                    });
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
            };
        }
        getSelectSymbolData(obj, dragID) {
            let num = 0;
            let targetLibrary = this.libPage == "searchLib" ? this.searchData : this.renderLibrary;
            for (let i = 0; i < targetLibrary.length; i++) {
                if (targetLibrary[i] && targetLibrary[i]["id"] == this.editLibrayID) {
                    // 搜索可能会存在数组还没加载完，数据为null的情况
                    num = i;
                    break;
                }
            }
            let symbolList = targetLibrary[num]["data"];
            let data = [];
            for (let i = 0; i < this.selectSymbolList.length; i++) {
                let id = this.selectSymbolList[i];
                for (let j = 0; j < symbolList.length; j++) {
                    let symbolItem = symbolList[j];
                    if (symbolItem["table_index"] == id) {
                        data.push({
                            shape: symbolItem.shape,
                            name: "name" in symbolItem ? symbolItem.name : undefined,
                            langName: symbolItem[`${this.lang}_name`] || symbolItem[`${this.lang}`],
                            obj,
                            dragID,
                        });
                    }
                }
            }
            return data;
        }
        handleClickImg() {}
        selectImg(e, shape, name, langName, index, tableID, tableName, table_index) {
            if (e.button == 2 || !shape) {
                return;
            } // 右键返回
            window["_view"]._tool.endEdit();
            this.currentShapeIndex = index;
            let target = e.target;
            let x = e.pageX;
            let y = e.pageY;
            this.drawImg(target, x - 80, y - 32);
            let a = document.getElementById("previewIMG");
            a.style.display = "none";
            a.style.pointerEvents = "none";
            let changeShapeFlag = false;
            let dropX, dropY;
            if (this.$store.state.ui.showDropdown) {
                this.$store.commit("setStatus", {
                    type: "showDropdown",
                    data: false,
                });
                this.$store.commit("setStatus", {
                    type: "showDropExpand",
                    data: false,
                });
                this.$store.commit("setStatus", {
                    type: "activeTabType",
                    data: -1,
                });
                this.$store.commit("setStatus", {
                    type: "activeFunc",
                    data: "",
                });
            }
            if (tableID != this.editLibrayID || (!this.selectSymbolList.includes(table_index) && !e.ctrlKey)) {
                this.cleanSymbolID();
            }
            this.getSymbolID(tableID, index, e.ctrlKey);
            document.onmousemove = (ev) => {
                if (ev.pageX - e.pageX == 0 || ev.pageY - e.pageY == 0) return;
                this.dragFlag = true;
                a.style.display = "block";
                a.style.opacity = "0.5";
                let movex = ev.pageX - x;
                let movey = ev.pageY - y - this.sceneTop;
                if (x + movex > this.sceneLeft) {
                    let obj = {
                        x: x + movex - this.sceneLeft,
                        y: y + movey,
                    };
                    if (!changeShapeFlag) {
                        // 移出的时候，一次性删除原预览图
                        this.removeImg();
                        changeShapeFlag = true;
                        let dragID = tableID >= this.collectTBID ? 0 : tableID;
                        // window['_view'].dragEnter(shape, name, langName, obj, dragID);
                        let symbolList = this.getSelectSymbolData(obj, dragID).filter(Boolean);
                        window["_view"].dragEnter(symbolList);
                        this.dragSymbolToPage = true;
                    }
                    window["_view"].dragMove(ev);
                } else {
                    if (changeShapeFlag) {
                        // 移回的时候，恢复原预览图
                        window["_view"].dragLeave();
                        this.drawImg(target, x, y);
                        a = document.getElementById("previewIMG");
                        changeShapeFlag = false;
                        this.dragSymbolToPage = false;
                        this.mouseMoveBack = true;
                    }
                    a.style.left = x + movex - 80 + "px";
                    a.style.top = y + movey - 32 + "px";
                }
                dropX = x + movex;
                dropY = y + movey;
                this.dragDirect = ev.offsetX < 24 ? 0 : 1;
            };
            document.onmouseup = (ev) => {
                this.dragSymbolToPage = false;
                let obj = {
                    x: dropX,
                    y: dropY,
                };

                this.$track("library", "use symbol", "drag" + `tableID:${tableID},shapeName:${name}`);
                const isLimitShape = !this.vip && ~this.limitTableIds.indexOf(tableID);
                window["_view"].dropToScene(ev, isLimitShape);
                if (isLimitShape) {
                    // sdk 不启用 vip 符号试用，直接调外壳购买
                    if (window.EDCONFIG.VIP.SYMBOL_LIMIT_ENABLE) {
                        this.$openBuyPage("library");
                    }
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "library",
                    });
                    window["_view"].addVipStatePoperList("vipShape");
                    if (tableID == 279) {
                        // this.$checkAuth({
                        //     type: "limitShapeType",
                        //     buyTrigger: "library",
                        //     libraryName: name,
                        // });
                        // 时间线
                        this.sensors.track("newTimeline", {
                            Catalogues: "SpecificDiagrams",
                            new_timeline_place: "fromLibrary",
                            new_timeline_type: "" + table_index,
                        });
                    }
                }

                this.trackUseLibrary(tableID, tableName);
                this.removeImg();
                if (!ev.ctrlKey && this.dragFlag) {
                    this.dropImg();
                    this.cleanSymbolID();
                }
                if (!ev.ctrlKey && !(this.selectSymbolList.length == 1 && this.selectSymbolList[0] == table_index)) {
                    this.cleanSymbolID();
                }
                this.dragFlag = false;
                document.onmousemove = null;
                document.onmouseup = null;
                window["_view"].updateRulers();
                this.dragDirect = -1;
            };
        }

        trackUseLibrary(tableID, tableName) {
            let hasTracked = this.trackedLibraryIds.find((v) => v.tableID === tableID);
            if (!hasTracked) {
                let temp = [...this.trackedLibraryIds];
                temp.push({
                    tableID,
                    tableName,
                });
                this.trackedLibraryIds = temp;
                this.sensors.track("useSymbolLibrary", {
                    Catalogues: "editFileProcess",
                    is_vip_library: !this.limitTableIds.indexOf(tableID),
                    symbol_library_name: tableName,
                    symbol_library_class: this.trackKey,
                });
            }
        }

        drawImg(img, x, y) {
            let a = document.getElementById("Library");
            let preview = img.cloneNode(true);
            preview.id = "previewIMG";
            preview.style.cssText = `position:absolute;left:${x}px;top:${y}px;max-width: 64px;max-height: 64px;object-fit:contain;pointer-events:none`;
            a.appendChild(preview);
        }
        removeImg() {
            let a = document.getElementById("Library");
            let b = document.getElementById("previewIMG");
            if (b) {
                a.removeChild(b);
            }
        }
        get limitTableIds() {
            return this.internal ? InternalLimitTableIds : OverseaLimitTableIds;
        }
        dbClickImg(e, shape, name, langName, tableID) {
            // 双击
            if (!shape || this.mouseMoveBack) {
                this.mouseMoveBack = false;
                return;
            }
            this.$track("library", "use symbol", "double click" + `tableID:${tableID},shapeName:${name}`);
            this.trackUseLibrary(tableID, name);
            const isLimitShape = !this.vip && ~this.limitTableIds.indexOf(tableID);
            if (isLimitShape) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "library",
                });
                // this.$checkAuth({
                //     type: "limitShapeType",
                //     buyTrigger: "library",
                //     libraryName: name,
                // });
                // return;
                // sdk 不启用 vip 符号试用，直接调外壳购买
                if (window.EDCONFIG.VIP.SYMBOL_LIMIT_ENABLE) {
                    this.$openBuyPage("library");
                    return;
                }
                window["_view"].addVipStatePoperList("vipShape");
            }
            window["_view"]._tool.endEdit();
            window["_view"].libDbClickAddShape(shape, name, langName, tableID, isLimitShape);
        }
        /**弹出框 */
        showModel(type) {
            // 弹library选择窗
            if (this.$store.state.ui.libraryLoadedStatus != 2) return; // 符号库未装载完成，禁止唤起弹窗
            this.activeFunc = "";
            this.lockExpand = false;
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "LibraryModal",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            window["_view"]._tool.endEdit();
            this.updateScrollInfo("get");
            this.sensors.track("moreLibraryButton", {
                Catalogues: "editFileProcess",
                type,
            });
            this.sensors.track("ShapeSetting", {
                Catalogues: "DiagramShapes",
            });
        }
        goSymbolCommu() {
            if (this.internal) {
                window.open("https://www.edrawmax.cn/templates/album/2028");
            } else {
                let url = location.origin + "/online/store?action=symbolAlbum";
                window.open(url);
            }
        }
        goAiSymbol() {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                this.$store.commit("setDialogState", {
                    type: "aiDrawBtn",
                    data: "libraryGoAiSymbol",
                });
                return;
            }
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "AIDraw",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$nextTick(() => {
                this.$bus.$emit("setAidrawOption", {
                    menu: 0,
                    style: 0,
                    text: this.renderLibSearchStr.trim(),
                });
            });
            this.sensors.track("openAiDrawingWindow", {
                Catalogues: "AiDrawing",
                open_way: "searchSymbolNoResult",
                similar_library_name: "unknown",
                similar_symbol_name: "unknown",
                search_symbol_content: this.renderLibSearchStr.trim(),
            });
        }
        updateScrollInfo(type: string) {
            let content = (this.$refs.libContainer as Vue).$el as HTMLElement;
            if (type == "set" && content.clientHeight != this.scrollToBottom) {
                content.scrollTop = this.scrollToBottom;
            } else if (type == "get") this.scrollToBottom = content.scrollHeight;
        }
        loadShapeImg(obj) {
            // 等待shape里面的图形加载完成
            return new Promise((RS, RJ) => {
                let promiseList = [];
                for (let i = 0; i < obj.length; i++) {
                    if (obj[i].tempIMG.length > 0) {
                        let imgList = obj[i].tempIMG;
                        for (let j = 0; j < imgList.length; j++) {
                            promiseList.push(
                                new Promise((res, rej) => {
                                    let imgString = imgList[j].slice(8, -2);
                                    let head = imgString.substr(0, 30);
                                    let img = new Image();
                                    if (/data\:image\/.+\;base64\,/.test(head)) {
                                        img.src = imgString;
                                    } else {
                                        img.src = `data:image/png;base64,${imgString}`;
                                    }
                                    img.onload = () => {
                                        res();
                                    };
                                })
                            );
                        }
                    }
                }
                Promise.all(promiseList).then((e) => {
                    RS();
                });
            });
        }
        tranGroupName(groupName, tableName) {
            // 翻译表名
            let menu = this.menuList;
            for (let i = 0; i < menu.length; i++) {
                if (menu[i].groupName == groupName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].tableName == tableName) {
                            return children[j][`tableName_${this.lang}`] || tableName;
                        }
                    }
                }
            }
        }
        checkVipSymbol(content: string) {
            let reg = new RegExp('FromLibId V="(\\d*)"', "g");
            let match;
            const list = [];
            while ((match = reg.exec(content))) {
                list.push(match[1]);
            }
            if (list) {
                for (let item of list) {
                    if (this.limitTableIds.includes(Number(item))) {
                        return true;
                    }
                }
            }
        }
        getTableData(groupName, tableId) {
            // 获取表数据
            if (this.scrollTimer) clearTimeout(this.scrollTimer);
            this.libsTranStr = "";
            let menu = this.menuList;
            let tablename = "";
            let tempData = {
                id: tableId,
                title: tablename,
                group: groupName,
                data: [],
            } as RenderLibraryData;
            for (let i = 0; i < menu.length; i++) {
                if (menu[i].groupName == groupName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].id == tableId) {
                            tablename = children[j].tableName;
                            tempData["title"] = children[j].tableName;
                            LangKeys.forEach((langKey) => {
                                tempData[langKey] = children[j][`tableName_${langKey}`];
                            });
                        }
                    }
                }
            }
            this.sensors.track("selectLibraries", {
                Catalogues: "editFileProcess",
                name: tempData.title,
                class: tableId >= this.collectTBID ? "mylibrary" : "shapes",
            });

            return new Promise((RS, RJ) => {
                if (!tablename) {
                    // 出错中断
                    RS();
                    return;
                }
                let opendb = window.indexedDB.open(groupName);
                opendb.onsuccess = (e) => {
                    let db = (e.target as IDBOpenDBRequest).result;
                    const tableNames = db.objectStoreNames;
                    if (!tableNames.contains(tablename)) {
                        db.close();
                        RS();
                        return;
                    }
                    let transaction = db.transaction(tablename);
                    let store = transaction.objectStore(tablename);
                    let request = store.openCursor();
                    request.onsuccess = (e) => {
                        let cursor = (e.target as IDBRequest).result;
                        if (cursor) {
                            let cursordata = cursor.value;
                            if (cursordata.data) {
                                let tempIMG = cursordata.data.match(/!\[CDATA\[[^\[\]]*?\]\]/g);
                                let obj = {
                                    table_index: cursordata.index,
                                    name: cursordata.name,
                                    url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                    blob: cursordata.blob,
                                    shape: cursordata.data,
                                    table_id: cursordata.tableID || tableId,
                                    tempIMG: tempIMG ? tempIMG : [],
                                    next: cursordata.next,
                                    hasControl: this.hasControlData(cursordata.data),
                                } as LibraryItem;

                                if (obj.table_id >= this.collectTBID) {
                                    Object.assign(obj, {
                                        isVip: this.checkVipSymbol(obj.shape),
                                    });
                                }

                                LangKeys.forEach((langKey) => {
                                    let k = `${langKey}_name`;
                                    obj[k] = cursordata[k];
                                });

                                tempData.data.push(obj);
                            }
                            cursor.continue();
                        } else {
                            if (tempData.data) {
                                tempData.data = this.mapSort(tempData.data);
                                this.sensors.track("openLibrarySuccess", {
                                    Catalogues: "editFileProcess",
                                    name: tempData.title,
                                    class: tableId >= this.collectTBID ? "mylibrary" : "shapes",
                                });
                            }
                            this.loadShapeImg(tempData.data).then((e) => {
                                RS({
                                    tableId,
                                    tempData,
                                });
                            });
                        }
                    };
                    db.close();
                };
                opendb.onerror = (e) => {
                    console.log(e);
                };
            });
        }

        hasControlData(data: string) {
            let controlRx = /<Control (.*?)<\/Control>/g;
            let disableRx = /<Disabled (.*?)>/g;
            let controls = data.match(controlRx);
            if (controls && controls.length) {
                for (let i = 0; i < controls.length; i++) {
                    let control = controls[i];
                    let disables = control.match(disableRx);
                    if (disables && disables.length) {
                        for (let k = 0; k < disables.length; k++) {
                            let disable = disables[k];
                            if (disable.indexOf('F="IFV(ISEMPTY(Text.') >= 0) {
                                continue;
                            }
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        addDataToList(dataList) {
            if (dataList.length == 0) return;
            let myLibraryData = this.$store.state.library.myLibraryData;
            let publicLibraryData = this.$store.state.library.publicLibraryData;
            let needResetMylibraryData = !!dataList.find((v) => v?.tableId === this.collectTBID);
            // 剔除没有shape的数据，这部分数据是脏的
            // 对比data与this.renderLibrary的数据，清除没有shape的项、data中包含的项
            myLibraryData = myLibraryData.filter((c) => (c as any).data.every((v) => v.shape) && !dataList.find((v) => v?.tableId === (c as any).id));
            if (needResetMylibraryData) {
                // 如果 datalist 里含有我的收藏，我的库的数据重建，排除云端库被删除的情况
                myLibraryData = [];
            }

            publicLibraryData = publicLibraryData.filter(
                (c) => (c as any).data.every((v) => v.shape) && !dataList.find((v) => v?.tableId === (c as any).id)
            );

            let sortList = window["_view"]._doc._librarys;
            let publicLibraryLibs = sortList.filter((v) => v < this.collectTBID);
            let fisrtExpandLibs = Array.from(new Set([sortList[0], sortList[sortList.length - 1], publicLibraryLibs[publicLibraryLibs.length - 1]]));
            let myPos = myLibraryData.length;
            let publicPos = publicLibraryData.length;

            for (let i = sortList.length - 1; i >= 0; i--) {
                for (let j = 0; j < dataList.length; j++) {
                    let item = dataList[j];
                    if (item && sortList[i] == item.tableId) {
                        let temp = dataList.splice(j, 1);
                        dataList.unshift(temp[0]);
                        break;
                    }
                }
            }
            let mycollectData;
            for (let item of dataList) {
                if (!item) continue;
                window["_view"].addLibrary(item.tableId); // 记录打开信息至文件
                let oldIndex = this.cacheLibraryOrder[item.tableId];
                if (item.tableId == this.collectTBID) {
                    mycollectData = item.tempData;
                    continue;
                } else if (item.tableId > this.collectTBID) {
                    if (oldIndex !== undefined) {
                        let temp = myLibraryData[oldIndex];
                        if (temp) {
                            let tempIndex = this.cacheLibraryOrder[temp.id];
                            myLibraryData[tempIndex] = temp;
                            myLibraryData.splice(oldIndex, 1, item.tempData);
                        } else {
                            myLibraryData[oldIndex] = item.tempData;
                        }
                    } else {
                        myLibraryData.splice(myPos++, 1, item.tempData);
                    }
                } else {
                    if (oldIndex !== undefined) {
                        let temp = publicLibraryData[oldIndex];
                        if (temp) {
                            let tempIndex = this.cacheLibraryOrder[temp.id];
                            publicLibraryData[tempIndex] = temp;
                            publicLibraryData.splice(oldIndex, 1, item.tempData);
                        } else {
                            publicLibraryData[oldIndex] = item.tempData;
                        }
                    } else {
                        publicLibraryData.splice(publicPos++, 1, item.tempData);
                    }
                }
                this.addedcount++;
                if (!this.lockExpand && (!this.firstAdd || fisrtExpandLibs.includes(item.tableId + ""))) {
                    this.expandLibIds.push(item.tableId);
                }
            }
            this.firstAdd = false;
            if (mycollectData) {
                // 我的收藏延后添加至库
                myLibraryData.unshift(mycollectData);
                this.expandLibIds.push(this.collectTBID);
                this.addedcount++;
            } else {
                if (this.libPage !== "searchLib") {
                    this.scrollTimer = setTimeout(() => {
                        this.$nextTick(() => {
                            this.updateScrollInfo("set");
                        });
                    }, 500);
                }
            }

            this.$store.commit("setLibraryState", {
                type: "myLibraryData",
                data: myLibraryData.filter(Boolean),
            });

            this.$store.commit("setLibraryState", {
                type: "publicLibraryData",
                data: publicLibraryData.filter(Boolean),
            });

            if (this.addedcount == this.addCount) {
                setTimeout(() => {
                    this.libsTranStr = "libsBox";
                }, 0);
            }
        }
        mapSort(linkedList) {
            var sortedList = [];
            var map = new Map();
            var currentId = null;

            for (var i = 0; i < linkedList.length; i++) {
                var item = linkedList[i];
                if (item.next === null) {
                    currentId = item.table_index;
                    sortedList.push(item);
                } else {
                    map.set(item.next, i);
                }
            }

            while (sortedList.length < linkedList.length) {
                var previousItem = linkedList[map.get(currentId)];
                if (previousItem) {
                    sortedList.unshift(previousItem);
                    currentId = previousItem.table_index;
                }
            }

            return sortedList;
        }
        cleanImg(list) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].url) {
                    URL.revokeObjectURL(list[i].url);
                }
            }
        }
        delTable(delId) {
            this.libsTranStr = "";
            let libName = "";
            let i = 0;
            for (; i < this.renderLibrary.length; i++) {
                if (this.renderLibrary[i]["id"] == delId) {
                    // this.cleanImg(this.renderLibrary[i]['data'])
                    libName = this.renderLibrary[i]["title"];
                    this.renderLibrary.splice(i, 1);
                    break;
                }
            }
            this.deledcount++;
            if (this.deledcount == this.delCount) {
                setTimeout(() => {
                    this.libsTranStr = "libsBox";
                }, 0);
            }
            window["_view"].removeLibrary(delId);
            this.sensors.track("libCloseAll", {
                Catalogues: "editFileProcess",
                name: libName,
                class: this.trackKey,
            });
        }
        updateTable(groupName, tableID = -1) {
            let index = -1;
            let tableName = "";
            let menu = this.menuList;
            for (let i = 0; i < menu.length; i++) {
                // 获取修改后的表名
                if (menu[i].groupName == groupName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].id == tableID) {
                            tableName = children[j].tableName;
                        }
                    }
                }
            }

            for (let i = 0; i < this.allRenderLibraryData.length; i++) {
                // 获取修改前在ui数组里的位置
                if (this.allRenderLibraryData[i]["id"] == tableID) {
                    index = i;
                }
            }

            if (index == -1) {
                // 不存在相应表
                this.contextLocker = false;
                return;
            }
            let tempArr = [];
            let opendb = window.indexedDB.open(groupName);
            opendb.onsuccess = (e) => {
                let db = (e.target as IDBOpenDBRequest).result;
                let transaction = db.transaction(tableName);
                let store = transaction.objectStore(tableName);
                let request = store.openCursor();
                request.onsuccess = (e) => {
                    let cursor = (e.target as IDBRequest).result;
                    if (cursor) {
                        let cursordata = cursor.value;
                        let cursorkey = cursor.key;
                        if (cursordata.data) {
                            let tempIMG = cursordata.data.match(/!\[CDATA\[[^\[\]]*?\]\]/g);
                            let obj = {
                                table_index: cursordata.index,
                                name: cursordata.name,
                                zh_name: cursordata.zh_name,
                                de_name: cursordata.de_name,
                                en_name: cursordata.en_name,
                                es_name: cursordata.es_name,
                                fr_name: cursordata.fr_name,
                                jp_name: cursordata.jp_name,
                                ru_name: cursordata.ru_name,
                                it_name: cursordata.it_name,
                                pt_name: cursordata.pt_name,
                                tw_name: cursordata.tw_name,
                                kr_name: cursordata.kr_name,
                                url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                blob: cursordata.blob,
                                shape: cursordata.data,
                                table_id: cursordata.tableID || tableID,
                                tempIMG: tempIMG ? tempIMG : [],
                                next: cursordata.next,
                                hasControl: this.hasControlData(cursordata.data),
                            };

                            if (obj.table_id >= this.collectTBID) {
                                Object.assign(obj, {
                                    isVip: this.checkVipSymbol(obj.shape),
                                });
                            }
                            tempArr.push(obj);
                        }
                        cursor.continue();
                    } else {
                        tempArr = this.mapSort(tempArr);
                        this.loadShapeImg(tempArr).then((e) => {
                            this.allRenderLibraryData[index]["data"] = [];
                            this.allRenderLibraryData[index]["title"] = tableName;
                            this.allRenderLibraryData[index]["data"] = tempArr;
                            this.contextLocker = false;
                        });
                    }
                };
                db.close();
            };
        }
        deleteTableFromUI(group, id) {
            let checkbox = this.$store.state.library.checkbox;
            let menu = this.menuList;
            let arr = checkbox[group];
            for (let i = 0; i < menu.length; i++) {
                // 找出弹窗对应的checkbox 取消勾选
                if (menu[i].groupName == group) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].id == id) {
                            this.$store.state.library.menuList[i].children[j].checked = false;
                        }
                    }
                }
            }
            for (let i = 0; i < arr.length; i++) {
                // 删除对应checkbox的数据
                if (arr[i] == id) {
                    arr.splice(i, 1);
                    break;
                }
            }
            checkbox[group] = arr;
            this.checkbox = checkbox;
            this.delTable(id);
        }
        deleteAllTable() {
            let temp = JSON.parse(JSON.stringify(this.checkbox));
            let list = Object.keys(temp);
            for (let name of list) {
                temp[name] = [];
            }
            window["_view"].reOrderLibrary([]);
            this.checkbox = temp;
        }
        /**我的符号库 */
        getLidFromTid(tableId) {
            let userInfo = this.userInfo;
            let list = this.$store.state.library.ossList;
            return new Promise((rs, _) => {
                this.$edApi.getCustomLibraryList({ id: userInfo.user_id, token: userInfo.token, type: 0 }).then((e) => {
                    let list = e.data;
                    for (let item of list) {
                        if (item.table_id == tableId) {
                            rs(item.id);
                        }
                    }
                    rs(-1);
                });
            });
        }
        get showUpgradeVal() {
            return this.$store.state.publicStore.showUpgrade;
        }

        checkCloudSpaceLimit() {
            if (this.isFullCouldSpace) {
                this.showCloudSpaceLimit();
                return true;
            }
            return false;
        }
        showCloudSpaceLimit() {
            if (!this.vip && this.showUpgradeVal != "cloudSpace") {
                this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
            } else if (this.vip && this.showUpgradeVal != "cloudSpaceVIP") {
                if (this.fuser) {
                    this.$bus.$emit("showCloudSpaceVipTips");
                } else {
                    this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                }
            }
        }
        uploadLibToCloud(message, isShowMessage = false) {
            // 上传至云
            console.log("上传云");
            if (this.checkCloudSpaceLimit()) return;
            let ossList = this.$store.state.library.ossList;
            let userInfo = this.userInfo;
            let ts: any = this;

            this.addSuccess = this.$t("addSuccess") as string;
            this.syncFail = this.$t("syncFail") as string;
            return new Promise((RS, RJ) => {
                if (message.isUserDB) {
                    let symbol_key = this.$store.state.library.collectTBSymbolKey;
                    let DB = message.data.group;
                    let TB = message.data.name;
                    let versionData = {
                        vTableName: `myDBVersion_${userInfo.user_id}`,
                        vTableID: message.data.tableID,
                    };
                    this.getLidFromTid(message.data.tableID).then((lid) => {
                        if (message.data.tableID == this.collectTBID) {
                            // 我的收藏
                            let collectDB = this.$store.state.library.extraDB[2],
                                collectTB = "collect";
                            clearTimeout(this.uploadCollectLibDelay);
                            this.uploadCollectLibDelay = setTimeout(() => {
                                window["_view"].saveLib(collectDB, collectTB, versionData).then((files) => {
                                    let fileSize = files[0].file.size + files[1].file.size;
                                    this.$store
                                        .dispatch("upLoadLibrary", {
                                            param: {
                                                id: userInfo.user_id,
                                                token: userInfo.token,
                                                targetUrl: "customlib",
                                                symbol_key,
                                                type: 1,
                                            },
                                            size: fileSize,
                                            files: files,
                                            tableName: collectTB,
                                            tableID: message.data.tableID,
                                            lid,
                                        })
                                        .then((e) => {
                                            if (this.isPrivate) {
                                                this.$store.commit("setLibraryState", {
                                                    type: "collectTBSymbolKey",
                                                    data: e.data.symbol_key,
                                                });
                                            } else {
                                                this.$store.commit("setLibraryState", {
                                                    type: "collectTBEdtKey",
                                                    data: e.data.edt.obj,
                                                });
                                            }
                                            // upload to cloud success
                                            isShowMessage && ts.$edMessage.success(this.addSuccess);
                                            RS(e);
                                        })
                                        .catch((err) => {
                                            if (err?.msg == "storage space not enough") {
                                                this.showCloudSpaceLimit();
                                            }
                                            // ts.$edMessage.error(this.syncFail);
                                        });
                                });
                            }, 1000);
                        } else {
                            let symbol_key = "";
                            if (["newOK", "updateOK", "moveUpOK", "moveDownOK", "deleteOK"].includes(message.type)) {
                                let inList = false;
                                for (let i = 0; i < this.customLibsQueue.length; i++) {
                                    if (this.customLibsQueue[i].data.tableID == message.data.tableID) {
                                        inList = true;
                                        break;
                                    }
                                }
                                this.customLibsQueue.push(message);
                            } else if (message.type == "deleteLib") {
                                for (let i = 0; i < this.customLibsQueue.length; i++) {
                                    if (this.customLibsQueue[i].data.tableID == message.data.tableID) {
                                        this.customLibsQueue.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                            clearTimeout(this.uploadCustomLibDelay);
                            this.uploadCustomLibDelay = setTimeout(() => {
                                if (this.isPrivate) {
                                    for (let item of ossList) {
                                        if (item.table_id == message.data.tableID) {
                                            symbol_key = item.symbol_key;
                                            break;
                                        }
                                    }
                                }
                                while (this.customLibsQueue.length > 0) {
                                    let message = this.customLibsQueue.shift();
                                    let DB = message.data.group;
                                    let TB = message.data.name;

                                    window["_view"].saveLib(DB, TB, versionData).then((files) => {
                                        let fileSize = files[0].file.size + files[1].file.size;
                                        this.$store
                                            .dispatch("upLoadLibrary", {
                                                param: {
                                                    id: userInfo.user_id,
                                                    token: userInfo.token,
                                                    targetUrl: "customlib",
                                                    symbol_key,
                                                    type: 0,
                                                },
                                                size: fileSize,
                                                files: files,
                                                tableName: TB,
                                                tableID: message.data.tableID,
                                                lid,
                                            })
                                            .then((e) => {
                                                // upload to cloud success
                                                this.$edApi
                                                    .getCustomLibraryList({
                                                        id: userInfo.user_id,
                                                        token: userInfo.token,
                                                        type: 0,
                                                    })
                                                    .then((e) => {
                                                        this.$store.commit("setLibraryState", {
                                                            type: "ossList",
                                                            data: e.data,
                                                        });
                                                    });

                                                isShowMessage && ts.$edMessage.success(this.addSuccess);
                                                RS(e);
                                            })
                                            .catch((err) => {
                                                if (err?.msg == "storage space not enough") {
                                                    this.showCloudSpaceLimit();
                                                }
                                                // ts.$edMessage.error(this.syncFail);
                                            });
                                    });
                                }
                            }, 1000);
                        }
                    });
                }
            });
        }
        addSymbolFromPage(db, tb, id) {
            this.$track("mylibrary", "clickaddbutton", "");
            this.addFromPage(db, tb, id);
        }
        addFromPage(db, tb, id, groupMulti = false) {
            if (this.isMap) return;
            let dbName = db;
            let tableName = tb;
            let tableID = id;
            let a = window["_view"].saveSymbolToData(groupMulti);
            a.then((data) => {
                if (data.type == "single") {
                    let symbolData = data.data;
                    let dbObj = {
                        data: symbolData.content,
                        parent: tableName,
                        blob: symbolData.data,
                        name: symbolData.name,
                    };
                    this.addSymbolToDB(dbName, tableName, tableID, dbObj, this.isShowMessage).then((e) => {
                        this.resetStatus();
                        this.expanded(id) || this.expandLibIds.push(id);
                    });
                    this.isShowMessage = false;
                } else if (data.type == "complex") {
                    let symbolList = data.data;
                    let insertData = [];
                    for (let i = 0; i < symbolList.length; i++) {
                        insertData.push({
                            index: i,
                            next: symbolList.length - 1 == i ? null : i + 1,
                            blob: symbolList[i].blob,
                            name: symbolList[i].name,
                            data: symbolList[i].content,
                        });
                    }
                    this.addSymbolsToDB(dbName, tableName, tableID, insertData, this.isShowMessage).then((e) => {
                        this.resetStatus();
                        this.expanded(id) || this.expandLibIds.push(id);
                    });
                    this.isShowMessage = false;
                }
            });
        }
        resetStatus() {
            this.showDragPreview = false;
            this.showDragNum = false;
            this.dragData = null;
            this.vueDragFlag = false;
            this.viewDragFlag = false;
        }
        nextOneDrag() {
            this.dragImgPromiseIndex++;
            this.dragImgPromisePos++;
            if (this.dragImgPromisePos > this.dragPromiseLimit) {
                // 超过最大长度限制，从头开始推入任务
                this.dragImgPromisePos = this.dragImgPromiseIndex % this.dragPromiseLimit;
                while (!this.dragImgPromiseDone[this.dragImgPromisePos]) {
                    if (this.dragImgPromisePos > this.dragPromiseLimit) this.dragImgPromisePos = this.dragImgPromiseIndex % this.dragPromiseLimit;
                    this.dragImgPromisePos++;
                }
                this.dragImgPromiseDone[this.dragImgPromisePos] = false;
                this.dragImgPromise[this.dragImgPromisePos] = null;
            }
        }
        dragSymbolEnter(e) {
            if (this.isMap) {
                this.viewDragFlag = false;
                return;
            }
            if (!this.viewDragFlag) return;
            this.vueDragFlag = true;
            let x = e.pageX,
                y = e.pageY - this.sceneTop;
            let a = this.$refs.dragImg as HTMLElement;
            this.dragImgPreview(x, y);
            document.onmousemove = (ev) => {
                if (ev.pageX - e.pageX == 0 || ev.pageY - e.pageY == 0) return;
                let movex = ev.pageX - x;
                let movey = ev.pageY - y - this.sceneTop;
                if (a) {
                    a.style.left = x + movex - 32 + "px";
                    a.style.top = y + movey - 32 + "px";
                }
            };
            document.onmouseup = (eeeev) => {
                this.dragOver();
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
        dragSymbolLeave(e) {
            if (!this.vueDragFlag) return;
            this.nextOneDrag();
            this.resetStatus();
        }
        libsEnter(id, name) {
            if (id < this.collectTBID) return;
            this.dragTBID = id;
            this.dragTBName = name;
            this.mutiselTBID = id;
            this.mutiselTBName = name;
        }
        libsLeave() {
            this.dragTBID = null;
            this.dragTBName = null;
        }
        addPreviewImgData() {
            let index = this.dragImgPromisePos;
            return this.dragImgPromise[index]?.then((e) => {
                if (!this.dragImgPromiseDone[index]) {
                    if (this.dragData) {
                        // 快速拖入拖出，前一个promise的dragdata可能为空值
                        if (e.type == "single") {
                            this.dragData.blob = e.data;
                        } else if (e.type == "complex") {
                            let imgList = e.data;
                            let xmlList = this.dragData.data;
                            for (let i = 0; i < xmlList.length; i++) {
                                xmlList[i].blob = imgList[i].blob;
                            }
                        }
                    }
                    this.dragImgPromiseDone[index] = true;
                }
            });
        }
        dragImgPreview(x, y) {
            let view = window["_view"];
            let symbolData = view.saveSymbolToXml();
            this.showDragPreview = true;
            this.showDragNum = true;
            if (!this.isMultisel) {
                this.dragImgPromise[this.dragImgPromisePos] = view.saveSymbolToBlob();
                this.dragImgPromiseDone[this.dragImgPromisePos] = null;
                if (symbolData?.type == "single") {
                    let obj = {
                        type: "single",
                        name: symbolData.name,
                        data: symbolData.data,
                        blob: null,
                    };
                    this.dragData = obj;
                    this.dragNum = "1";
                } else if (symbolData?.type == "complex") {
                    let obj = {
                        type: "complex",
                        data: symbolData.data,
                    };
                    this.dragData = obj;
                    let str = symbolData.data.length > 99 ? "99+" : symbolData.data.length;
                    this.dragNum = str;
                }
            } else {
                let str = this.multiSelCount > 99 ? "99+" : this.multiSelCount;
                this.dragNum = str;
            }
        }
        dragOver() {
            if (!this.vueDragFlag) return;
            if (!this.isMultisel) {
                this.addPreviewImgData()?.then((e) => {
                    if (this.dragTBID && this.dragTBName) {
                        let dbName = this.$store.state.library.extraDB[2];
                        let tableName = this.dragTBName;
                        let tableID = this.dragTBID;
                        if (this.dragData.type == "single") {
                            let symbolData = this.dragData;
                            let dbObj = {
                                name: symbolData.name || "",
                                data: symbolData.data || "",
                                parent: tableName,
                                blob: symbolData.blob || "",
                            };
                            this.addSymbolToDB(dbName, tableName, tableID, dbObj).then((e) => {
                                this.resetStatus();
                            });
                        } else if (this.dragData.type == "complex") {
                            let symbolList = this.dragData.data;
                            let insertData = [];
                            for (let i = 0; i < symbolList.length; i++) {
                                insertData.push({
                                    index: i,
                                    next: symbolList.length - 1 == i ? null : i + 1,
                                    blob: symbolList[i].blob || "",
                                    name: symbolList[i].name || "",
                                    data: symbolList[i].content || "",
                                });
                            }
                            this.addSymbolsToDB(dbName, tableName, tableID, insertData).then((e) => {
                                this.resetStatus();
                            });
                        }
                    } else {
                        this.resetStatus();
                    }
                });
                this.nextOneDrag();
            } else {
                window["_view"].cancelDragShape();
                let msg = this.$t("groupSymbolsTips");
                this.showMessage({
                    sponsor: "addSymbolsToLibs",
                    uniqueListenr: true,
                    type: 0,
                    btnType: 1,
                    content: msg,
                });
            }
        }
        addSymbolToDB(dbName, tableName, tableID, dbObj, isShowMessage = false) {
            // 添加单个符号到库
            return new Promise((rs, rj) => {
                let userInfo = this.$store.state.user.userInfo;
                let updateData = {
                    DBName: dbName,
                    tableName: tableName,
                    tableID: tableID,
                    nowItem: -1,
                    updateType: "addSymbol",
                    dbObj: dbObj,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                };

                this.worker = new Worker(this.userWorkerURL);
                this.worker.postMessage({
                    type: "update",
                    urls: this.urls,
                    data: updateData,
                });
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "updateOK") {
                        this.updateTable(dbName, tableID);
                        this.uploadLibToCloud(message, isShowMessage).then((e: any) => {
                            let version = e.data.version;
                            this.worker.postMessage({
                                type: "setVersion",
                                urls: this.urls,
                                data: {
                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                    tableID: tableID,
                                    version,
                                    params: {
                                        updateModified: true,
                                    },
                                },
                            });
                        });
                        this.$store.commit("setLibraryDisplayList", {
                            // 清空预览缓存
                            groupName: dbName,
                            tableName: tableName,
                            data: [],
                        });
                        rs();
                    } else if (message.type === "setVersionOK") {
                        this.worker.terminate();
                    }
                };
            });
        }
        addSymbolsToDB(dbName, tableName, tableID, insertData, isShowMessage = false) {
            // 添加多个符号到库
            return new Promise((rs, rj) => {
                let userInfo = this.$store.state.user.userInfo;
                let ts: any = this;
                this.worker = new Worker(this.userWorkerURL);
                let updateData = {
                    DBName: dbName,
                    tableName: tableName,
                    tableID: tableID,
                    nowItem: -1,
                    updateType: "addSymbols",
                    insertData: insertData,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                };
                this.worker.postMessage({
                    type: "update",
                    urls: this.urls,
                    data: updateData,
                });
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "updateOK") {
                        this.updateTable(dbName, tableID);
                        this.uploadLibToCloud(message, isShowMessage).then((e: any) => {
                            let version = e.data.version;
                            this.worker.postMessage({
                                type: "setVersion",
                                urls: this.urls,
                                data: {
                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                    tableID: tableID,
                                    version,
                                    params: {
                                        updateModified: true,
                                    },
                                },
                            });
                        });
                        this.$store.commit("setLibraryDisplayList", {
                            // 清空预览缓存
                            groupName: dbName,
                            tableName: tableName,
                            data: [],
                        });
                        rs();
                    } else if (message.type === "setVersionOK") {
                        this.worker.terminate();
                    }
                };
            });
        }
        confirmAddSymbolsByGroup() {
            let tableName, dbName, tableID;
            if (Object.keys(this.fromPageShape).length) {
                tableName = this.fromPageShape.tableName;
                dbName = this.fromPageShape.dbName;
                tableID = this.fromPageShape.tableID;
                this.fromPageShape = {};
            } else {
                this.$track("mylibrary", "clickgroupbutton", "type: yes");
                tableName = this.mutiselTBName;
                dbName = this.$store.state.library.extraDB[2];
                tableID = this.mutiselTBID;
            }

            this.addFromPage(dbName, tableName, tableID, true);
        }
        cancelAddSymbolsByGroup() {
            let tableName, dbName, tableID;
            if (Object.keys(this.fromPageShape).length) {
                tableName = this.fromPageShape.tableName;
                dbName = this.fromPageShape.dbName;
                tableID = this.fromPageShape.tableID;
                this.fromPageShape = {};
            } else {
                this.$track("mylibrary", "clickgroupbutton", "type: no");
                tableName = this.mutiselTBName;
                dbName = this.$store.state.library.extraDB[2];
                tableID = this.mutiselTBID;
            }

            this.addFromPage(dbName, tableName, tableID, false);
        }

        // 排序libs
        clickLibTitle(e, index, id) {
            // 拖拽排序库位置
            let dom = (this.$refs.libContainer as Vue).$el as HTMLElement;
            let content = this.$refs.libsList["$el"] as HTMLElement;
            let target = e.target,
                libList = [],
                baseScrollTop = dom.scrollTop,
                clickLeft = e.clientX,
                clickTop = e.clientY,
                clickIndex = index;
            let prevId;
            let nextId;

            let getWidth = (target, arr) => {
                for (let i = 0; i < target.children.length; i++) {
                    arr.push(target.children[i].getBoundingClientRect().height);
                }
            };
            getWidth(content, libList);
            let offsetHeight = libList[index] / 2;
            let crossHeight = 0;
            document.onmousemove = (ev) => {
                let scrollTop = dom.scrollTop - baseScrollTop;
                let moveLeft = ev.clientX,
                    moveTop = ev.clientY;
                if (moveLeft == clickLeft || moveTop == clickTop) {
                    return;
                }
                if (!this.moveFlag) {
                    this.opacityIndex = index;
                }
                this.moveFlag = true;
                let offsetY = moveTop - clickTop + scrollTop + crossHeight;

                if (offsetY < 0) {
                    // 上移
                    let num = index;
                    let height = offsetY;
                    for (let i = index; i >= 0; i--) {
                        if (height + libList[i - 1] < 0 && num > 0) {
                            height += libList[i - 1];
                            crossHeight += libList[i - 1];
                            this.opacityIndex = --num;
                            prevId = this.renderLibrary[i].id;
                            nextId = this.renderLibrary[i - 1].id;
                            [this.renderLibrary[i], this.renderLibrary[i - 1]] = [this.renderLibrary[i - 1], this.renderLibrary[i]];
                            [libList[i], libList[i - 1]] = [libList[i - 1], libList[i]];
                            // this.$forceUpdate()
                        } else {
                            index = num;
                            this.opacityIndex = num;
                            break;
                        }
                    }
                } else {
                    // 下移
                    let num = index;
                    let height = offsetY;
                    for (let i = index; i <= libList.length - 1; i++) {
                        if (height - libList[i + 1] > 0 && num < libList.length - 1) {
                            height -= libList[i + 1];
                            crossHeight -= libList[i + 1];
                            prevId = this.renderLibrary[i].id;
                            nextId = this.renderLibrary[i + 1].id;
                            [this.renderLibrary[i], this.renderLibrary[i + 1]] = [this.renderLibrary[i + 1], this.renderLibrary[i]];
                            [libList[i], libList[i + 1]] = [libList[i + 1], libList[i]];
                            this.opacityIndex = ++num;
                            // this.$forceUpdate()
                        } else {
                            index = num;
                            this.opacityIndex = num;
                            break;
                        }
                    }
                }
            };
            document.onmouseup = () => {
                !this.moveFlag && this.toggleExpand(id, index);
                if (this.moveFlag) {
                    let idArr = this.renderLibrary.map((item) => {
                        return "" + item["id"];
                    });
                    if (prevId && nextId) {
                        this.reOrderViewLibrary(prevId, nextId);
                    }
                }
                this.moveFlag = false;
                this.opacityIndex = -1;

                document.onmouseup = null;
                document.onmousemove = null;
            };
        }

        reOrderViewLibrary(prevId, nextId) {
            let view = window["_view"];
            let viewLibrarys = view._doc._librarys;
            let preIndex = viewLibrarys.indexOf(prevId + "");
            let nextIndex = viewLibrarys.indexOf(nextId + "");
            [viewLibrarys[preIndex], viewLibrarys[nextIndex]] = [viewLibrarys[nextIndex], viewLibrarys[preIndex]];
        }
        moveLibTitleUp() {
            let t = this.selectLibraryTitlePos[0];
            if (t == 0) return;
            let a = this.renderLibrary;
            let prevId = a[t].id;
            let nextId = a[t - 1].id;
            [a[t], a[t - 1]] = [a[t - 1], a[t]]; // 和上一个换位置
            this.reOrderViewLibrary(prevId, nextId);
            this.$forceUpdate();
        }
        moveLibTitleDown() {
            let t = this.selectLibraryTitlePos[0];
            let a = this.renderLibrary;
            if (t == a.length - 1) return;
            let prevId = a[t].id;
            let nextId = a[t + 1].id;
            [a[t], a[t + 1]] = [a[t + 1], a[t]]; // 和下一个换位置

            this.reOrderViewLibrary(prevId, nextId);
            this.$forceUpdate();
        }
        hideLibrary() {
            const group = this.dbAndTable[0];
            const id = this.dbAndTable[2];
            this.deleteTableFromUI(group, id);
        }
        reloadLibrary() {
            // 容错，加载符号库失败的时候提供重试机制
            this.$bus.$emit("reloadLibrary");
        }

        get libraryLoadedStatus() {
            return this.$store.state.ui.libraryLoadedStatus == 2 || this.loadFromCache;
        }
        get libraryError() {
            return this.$store.state.library.libraryError;
        }
        get isMap() {
            return this.$store.state.shape.type == "EDChart" && this.$store.state.echart.chartType == "map";
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        get isMultisel() {
            return this.$store.state.shape.isMultiSel;
        }
        get multiSelCount() {
            return this.$store.state.shape.multiSelCount;
        }
        get collectTBID() {
            return this.$store.state.library.collectTBID;
        }
        get dragData() {
            return this.$store.state.library.dragData;
        }
        set dragData(data) {
            this.$store.commit("setLibraryState", {
                type: "dragData",
                data: data,
            });
        }
        get viewDragFlag() {
            return this.$store.state.library.viewDragFlag;
        }
        set viewDragFlag(data) {
            this.$store.commit("setLibraryState", {
                type: "viewDragFlag",
                data: data,
            });
        }
        get vueDragFlag() {
            return this.$store.state.library.vueDragFlag;
        }
        set vueDragFlag(data) {
            this.$store.commit("setLibraryState", {
                type: "vueDragFlag",
                data: data,
            });
        }
        get dragSymbolToPage() {
            return this.$store.state.library.dragSymbolToPage;
        }
        set dragSymbolToPage(data) {
            this.$store.commit("setLibraryState", {
                type: "dragSymbolToPage",
                data: data,
            });
        }
        get selectLibraryTitlePos() {
            return this.$store.state.library.selectLibraryTitlePos;
        }
        get libPage() {
            return this.$store.state.library.libPage;
        }
        set libPage(v) {
            this.$store.commit("setLibraryState", {
                type: "libPage",
                data: v,
            });
        }
        get menuList() {
            return this.$store.state.library.menuList;
        }
        get updateLibraryFlag() {
            return this.$store.state.ui.updateLibrary;
        }
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        set sceneLeft(v) {
            this.$store.commit("setStatus", {
                type: "sceneLeft",
                data: v,
            });
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop;
        }
        get fileID() {
            return this.$store.state.ui.fileID;
        }
        get checkbox() {
            return this.$store.state.library.checkbox;
        }
        set checkbox(v) {
            this.$store.commit("setLibraryState", {
                type: "checkbox",
                data: v,
            });
        }
        get contextLocker() {
            return this.$store.state.library.contextLocker;
        }
        set contextLocker(v) {
            this.$store.commit("setLibraryState", {
                type: "contextLocker",
                data: v,
            });
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        get isGroupView() {
            return this.$store.state.ui.isGroupView;
        }

        get activeRenderList() {
            // 当前打开的符号库id列表
            return this.renderLibrary.map((item) => item["id"]);
        }

        get trackedLibraryIds() {
            return this.$store.state.library.trackedLibraryIds;
        }
        set trackedLibraryIds(v) {
            this.$store.commit("setLibraryState", {
                type: "trackedLibraryIds",
                data: v,
            });
        }

        // addSearchResultTimer = 0;
        addSearchResultToList = throttle((item) => {
            // 把搜索结果添加到渲染列表内
            let tempCheckbox = JSON.parse(JSON.stringify(this.checkbox));
            let menu = this.menuList;
            for (let group of menu) {
                for (let child of group.children) {
                    if (child.id == item.tableId) {
                        tempCheckbox[group.groupName].push(item.tableId);
                        this.$store.commit("setLibraryState", {
                            type: "checkbox",
                            data: tempCheckbox,
                        });
                        break;
                    }
                }
            }
        }, 100);

        deleteFromSearchResult(item) {
            let tempCheckbox = JSON.parse(JSON.stringify(this.checkbox));
            let menu = this.menuList;
            for (let group of menu) {
                for (let child of group.children) {
                    if (child.id == item.tableId) {
                        this.deleteTableFromUI(group.groupName, item.tableId);
                        break;
                    }
                }
            }
        }

        firstAdd = true;
        @Watch("checkbox", { deep: true })
        watchCheckbox(newv, oldv) {
            if (newv && Object.keys(newv).length > 0 && Object.keys(oldv).length > 0) {
                let addData = {};
                let delData = {};
                let newvGroupName = Object.keys(newv);
                let oldvGroupName = Object.keys(oldv);
                let newLength = newvGroupName.length;
                let oldLength = oldvGroupName.length;
                let length = Math.max(newLength, oldLength);
                for (let i = 0; i < length; i++) {
                    // 处理数据
                    let newvData = newv[newvGroupName[i]];
                    let oldvData = oldv[newvGroupName[i]];
                    if (newvData && oldvData) {
                        let a = this.difArr(newvData, oldvData);
                        if (a) {
                            addData[newvGroupName[i]] = a;
                            this.addCount += a.length;
                        }
                        let b = this.difArr(oldvData, newvData);
                        if (b) {
                            delData[newvGroupName[i]] = b;
                            this.delCount += b.length;
                        }
                    }
                }
                // addData; 增加的数据
                // delData; 删除的数据

                let delTableName = Object.keys(addData);
                for (let i = 0; i < delTableName.length; i++) {
                    if (delTableName[i].length != 0) {
                        let temp = this.renderGroup[delTableName[i]]; // 原有的数据
                        let delTemp = delData[delTableName[i]]; // 删除的数据

                        for (let a = 0; a < delData[delTableName[i]].length; a++) {
                            this.delTable(delData[delTableName[i]][a]);
                        }
                        let data = this.difArr(temp, delTemp);
                        this.renderGroup[delTableName[i]] = data;
                    }
                }

                let addTableName = Object.keys(addData);
                let addList = [];
                for (let i = 0; i < addTableName.length; i++) {
                    if (addData[addTableName[i]].length != 0) {
                        let temp = this.renderGroup[addTableName[i]];
                        if (temp) {
                            temp = temp.concat(addData[addTableName[i]]);
                        } else {
                            temp = addData[addTableName[i]];
                        }
                        for (let a = 0; a < addData[addTableName[i]].length; a++) {
                            addList.push(this.getTableData(addTableName[i], addData[addTableName[i]][a]));
                        }
                        this.renderGroup[addTableName[i]] = temp;
                    }
                }
                Promise.all(addList).then((data) => {
                    this.addDataToList(data);
                    this.trackEnterSuccess && this.trackEnterSuccess();
                });
            }
        }

        @Watch("allRenderLibraryData")
        watchRenderLibrary(val) {
            const cacheObj = {
                fileID: this.fileID,
                data: val.map((v) => ({
                    ...v,
                    data: v.data.map((c) => {
                        const { shape, ...ret } = c;
                        ret.url = "";
                        return ret;
                    }),
                })),
            };
            const nowCache = localStorage.getItem("CacheRenderLibrary");
            if (!nowCache) {
                localStorage.setItem("CacheRenderLibrary", JSON.stringify([cacheObj]));
                return;
            }
            const nowCacheArr = JSON.parse(nowCache);
            const fin = nowCacheArr.findIndex((v) => v.fileID === this.fileID);
            if (fin > -1) nowCacheArr.splice(fin, 1);
            while (nowCacheArr.length > 6) nowCacheArr.shift(); // 缓存数量不得大于6
            nowCacheArr.push(cacheObj);
            localStorage.setItem("CacheRenderLibrary", JSON.stringify(nowCacheArr));
        }

        @Watch("fileID")
        watchFileID(val) {
            if (val && !this.allRenderLibraryData.length) this.checkCacheRenderLibrary();
        }

        trackEnterSuccess() {
            this.sensors.track("enterCanvasSuccess", {
                Catalogues: "openFileProcess",
                file_source: this.$store.state.user.file_source,
                template_type: this.$store.state.user.template_type,
            });
            console.log("entercanvassuccess");
            this.trackEnterSuccess = null;
        }
        // 将之前缓存的图形库加载出来，是剔除shape后的，也就是说只能展示，并不具备真实的图形功能。扔需等待真正的图形库加载完成。
        checkCacheRenderLibrary() {
            const nowCache = localStorage.getItem("CacheRenderLibrary");
            if (!nowCache) return;
            const nowCacheArr = JSON.parse(nowCache);
            const fin = nowCacheArr.find((v) => v.fileID === this.fileID);
            if (!fin) return;
            let result = fin.data;
            this.loadFromCache = true;
            const copyCacheRenderLibrary = [...result];
            // 先展示列表，分步渲染
            const renderShapeData = () => {
                const item = copyCacheRenderLibrary.shift() as any;
                if (!copyCacheRenderLibrary.length) {
                    const publicData = [];
                    const myData = [];
                    result.forEach((v, index) => {
                        this.cacheLibraryOrder[v.id] = index;
                        if (v.id >= this.collectTBID) {
                            myData.push(v);
                        } else {
                            publicData.push(v);
                        }
                    });
                    publicData.forEach((v) => {
                        this.cacheLibraryOrder[v.id] -= myData.length;
                    });
                    this.$store.commit("setLibraryState", {
                        type: "myLibraryData",
                        data: myData,
                    });

                    this.$store.commit("setLibraryState", {
                        type: "publicLibraryData",
                        data: publicData,
                    });
                }
                if (!item) {
                    return;
                }
                // this.getTableData 依赖menulist，暂不用
                const openRequest = indexedDB.open(item.group);
                openRequest.onsuccess = (e) => {
                    try {
                        const db = (e.target as IDBOpenDBRequest).result;
                        const transaction = db.transaction(item.title, "readonly");
                        const objectStore = transaction.objectStore(item.title);
                        const addUrl = (sh: any, callback = null) => {
                            objectStore.get(sh.table_index).onsuccess = (e) => {
                                const data = (e.target as IDBRequest).result;
                                if (result.includes(item) && data) {
                                    sh.shape = data.data;
                                    // 这里图形的image在没有缓存的情况下会报图片加载错误，但是不影响。因为没缓存的情况也不会前置加载
                                    sh.url = data.blob && URL.createObjectURL(data.blob);
                                }
                                callback && callback();
                            };
                        };
                        item.data.forEach((sh: any) => {
                            addUrl(sh);
                        });
                        if (result.includes(item)) {
                            renderShapeData();
                        }
                    } catch (err) {
                        if (result.includes(item)) {
                            renderShapeData();
                        }
                    }
                };
            };
            renderShapeData();
        }

        showFixTips = false;
        fixTipsDom = null;
        useFixTips = true;
        tipControlImgStr = "";

        checkFixTips(target) {
            // 检查是否需要弹出提示
            // let key = this.dragTitle;
            let checkLocal = () => {
                let showfix = localStorage.getItem("libCtrlTips") || "";
                if (!!showfix) {
                    return false;
                }
                localStorage.setItem("libCtrlTips", "1");
                return true;
            };
            if (checkLocal()) {
                let dom = target as HTMLElement;
                if (dom) {
                    let controls = dom.getElementsByClassName("library-control");
                    if (controls.length) {
                        dom = controls[0] as HTMLElement;
                        if (!this.tipControlImgStr) this.tipControlImgStr = dom.outerHTML;
                    }
                }
                this.fixTipsDom = dom;
                this.showFixTips = true;
            }
        }

        closeFixTips() {
            this.showFixTips = false;
        }

        get tipText() {
            let titleStr = `<div style="font-weight: bold; margin-bottom: 5px;">${this.$t("tipTitle")}</div>`;
            let contentStr = `<div>${this.$t("tipContent")}</div>`;
            if (this.tipControlImgStr) {
                titleStr = titleStr.replace("%1", " " + this.tipControlImgStr);
                contentStr = contentStr.replace("%1", " " + this.tipControlImgStr);
            }
            let str = titleStr + contentStr;
            return str;
        }
        downloadLibraryData(obj, newCheckBox) {
            let toggleLoading = (data) => {
                this.$store.commit("setStatus", {
                    type: "libraryLoadedStatus",
                    data,
                });
            };
            let downloadDBs = (arr) => {
                // 同时下载多个库
                return new Promise((rs, rj) => {
                    this.worker = new Worker(this.libraryWorkerURL);
                    this.worker.postMessage({
                        type: "checkAll",
                        arr,
                        urls: this.urls,
                    });
                    this.worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "download error") {
                            this.worker.terminate();
                            (<any>this).$edMessage.warning(this.$t("createFail"));
                            rj(message);
                        }
                        if (message.type === "loaded") {
                            this.worker.terminate();
                            rs();
                        }
                    };
                });
            };

            let downLoadDBNames = Object.keys(obj);
            let getData = () => {
                if (!downLoadDBNames.length) {
                    toggleLoading(2);
                    this.checkbox = newCheckBox;
                    return;
                }
                let downloadDBName = downLoadDBNames.shift();
                let downloadList = obj[downloadDBName];
                downloadDBs(downloadList)
                    .then(() => {
                        getData();
                    })
                    .catch((err) => {
                        getData();
                    });
            };
            if (downLoadDBNames.length) {
                toggleLoading(0);
                this.loadFromCache = false;
                getData();
            } else {
                this.checkbox = newCheckBox;
            }
        }

        agree = false;
        get agreePlus() {
            return this.agree || this.noLoginEditor;
        }
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        readLocal() {
            let str = localStorage.getItem("ai3") || null;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj.agreement || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.user_id == list[i].user_id) {
                        exit = true;
                        this.agree = list[i].data;
                        break;
                    }
                }
                !exit && (this.agree = false);
            } else {
                this.agree = false;
            }
            return this.agree;
        }
        showAgreement() {
            this.$store.commit("setDialogState", {
                type: "aiDrawBtn",
                data: "",
            });
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("showAgreement", true);
            });
        }
        showAiDraw() {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                this.$store.commit("setDialogState", {
                    type: "aiDrawBtn",
                    data: "libraryShowAiDraw",
                });
                return;
            }
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "AIDraw",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$nextTick(() => {
                this.$bus.$emit("setAidrawOption", {
                    menu: 0,
                    style: 0,
                });
            });
            this.sensors.track("openAiDrawingWindow", {
                Catalogues: "AiDrawing",
                open_way: "leftMenuAiSymbols",
                similar_library_name: "unknown",
                similar_symbol_name: "unknown",
                search_symbol_content: "unknown",
            });
        }

        mounted() {
            let checker = setInterval(() => {
                if (this.userInfo) {
                    clearInterval(checker);
                }
            }, 2000);
            this.$bus.$on("libraryChecked", () => {
                this.firstAdd = false;
            });
            this.$bus.$on("deleteSymbol", () => {
                this.deleteSymbol();
            });
            this.$bus.$on("mutiAddShape", (obj) => {
                this.mutiAddShape(obj);

                // this.deleteSymbol()
            });
            this.$bus.$on("downloadLibrary", (obj, newCheckBox) => {
                this.downloadLibraryData(obj, newCheckBox);
            });
            this.$bus.$on("libraryShowAiDraw", () => {
                this.showAiDraw();
            });
            this.$bus.$on("libraryGoAiSymbol", () => {
                this.goAiSymbol();
            });
        }
        fromPageShape: any = {};

        created() {
            let ts: any = this;
            ts.$bus.$on("msgOperation-addSymbolsToLibs", (data) => {
                if (data.sponsor == "addSymbolsToLibs") {
                    if (data.data) this.confirmAddSymbolsByGroup();
                    else this.cancelAddSymbolsByGroup();
                }
            });
            ts.$bus.$on("open-addSymbolsToLibs", (data) => {
                let msg = this.$t("groupSymbolsTips");
                this.showMessage({
                    sponsor: "addSymbolsToLibs",
                    uniqueListenr: true,
                    type: 0,
                    btnType: 1,
                    content: msg,
                });
                this.isShowMessage = data.isShowMessage;
                this.fromPageShape = data;
            });
            ts.$bus.$on("addSymbolToDB", ({ dbName, tableName, tableID, dbObj, isShowMessage }) => {
                this.addSymbolToDB(dbName, tableName, tableID, dbObj, isShowMessage).then(() => {
                    this.expanded(tableID) || this.expandLibIds.push(tableID);
                });
            });
            ts.$bus.$on("setLibrary", (data) => {
                if (data.type === "updateLibrary") {
                    this.updateTable(data.groupName, data.tableID);
                }
            });
            ts.$bus.$on("uploadToCloud", (obj: any) => {
                let { payload, resolve, reject } = obj;
                let { message, isShowMessage = false } = payload;
                ts.uploadLibToCloud(message, isShowMessage).then((e) => resolve(e));
            });
            ts.$bus.$on("libTitleAction", (data) => {
                if (data == "up") {
                    this.moveLibTitleUp();
                } else if (data == "down") {
                    this.moveLibTitleDown();
                } else if (data == "delete") {
                    this.deleteAllTable();
                } else if (data === "unShow") {
                    this.hideLibrary();
                } else if (data === "expandAll") {
                    this.expandLibIds = this.renderLibrary.map((v) => v.id);
                } else if (data === "collapseAll") {
                    this.expandLibIds = [];
                }
            });
            ts.$bus.$on("limitShapeCallback", (data) => {
                if (data.type == "dragLibrarySymbol") {
                    this.mouseUpEvent();
                }
            });

            ts.$bus.$on("openEditLibriary", (tableID) => {
                if (tableID) {
                    let item = this.renderLibrary.find((item: any) => item.id === tableID);
                    this.editSelfLibrary(item);
                }
            });

            ts.$bus.$on("selectAllSymbol", (tableID) => {
                this.selectAllSymbol(tableID);
            });
            ts.$bus.$on("publishLibrary", (tableID) => {
                this.publishLibrary(tableID);
            });
            ts.$bus.$on("useStoreSymbolExpand", (tableID) => {
                this.lockExpand = true;
                this.expandLibIds = [];
                this.expandLibIds.push(tableID);
            });
            ts.$bus.$on("updateSearchSymbol", (res) => {
                const { ID, clickIndex, blob, data } = res;
                let index = -1;
                for (let i = 0; i < this.searchData.length; i++) {
                    // 获取修改前在ui数组里的位置
                    if (this.searchData[i]["id"] == ID) {
                        index = i;
                    }
                }
                if (index != -1) {
                    data && (this.searchData[index]["data"][clickIndex].shape = data);
                    blob && (this.searchData[index]["data"][clickIndex].url = URL.createObjectURL(blob));
                    blob && (this.searchData[index]["data"][clickIndex].blob = blob);
                    this.searchData[index]["data"][clickIndex][`${this.lang}_name`] = res[`${this.lang}_name`];
                    this.searchData.splice(index, 1, this.searchData[index]);
                }
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("setLibrary");
            ts.$bus.$off("uploadToCloud");
            ts.$bus.$off("libTitleAction");
            ts.$bus.$off("msgOperation-addSymbolsToLibs");
            ts.$bus.$off("open-addSymbolsToLibs");
            ts.$bus.$off("addSymbolToDB");
            ts.$bus.$off("selectAllSymbol");
            ts.$bus.$off("useStoreSymbolExpand");
            ts.$bus.$off("updateSearch");
            ts.$bus.$off("libraryShowAiDraw");
            ts.$bus.$off("libraryGoAiSymbol");
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "我的符号库",
    "close": "关闭",
    "searchSymbol": "查找符号",
    "collectSymbol": "我的收藏",
    "toggleLib": "隐藏符号库",
    "searchTitle": "搜索记录",
    "searchOK": "搜索完成",
    "searchResult": "搜索结果",
    "searchIng": "搜索中",
    "noResult": "很抱歉，未匹配到您输入的关键词 \"{keyWord}\"。请尝试搜索其他关键词，或者去符号社区搜索哦~",
    "noResultSdk": "很抱歉，未匹配到您输入的关键词 \"{keyWord}\"。请尝试搜索其他关键词。",
    "symbolCommunity": "符号社区",
    "syncSuccess": "同步至云成功",
    "syncFail": "同步至云失败",
    "myCollect": "我的符号库",
    "edrawMaxLib": "亿图图示符号库",
    "noCollect": "暂无符号",
    "addCollect": "前往添加",
    "addMoreShape": "更多符号",
    "expandLib": "全部展开",
    "foldLib": "全部折叠",
    "editLib": "编辑符号库",
    "addFromPage": "选中图形添加到此库",
    "dragHere": "拖拽画布内元素到此处",
    "groupSymbolsTips": "是否将选中形状组合为一个符号添加",
    "addSuccess": "添加成功",
    "loading": "正在为您加载",
    "loadFail": "加载失败，",
    "retry": "请重试",
    "addSearchResultToRender": "显示",
    "deleteFromSearchResult": "不显示",
    "tipTitle": "选择带%1的形状可以调整节点哦！",
    "tipContent": "选择形状后，将光标放置在%1的位置，长按鼠标左键拖动形状来改变样式",
    "more": "更多",
    "addNewLibrary": "添加符号库",
    "createFail": "下载失败，请检查网络",
    "symbol": "符号",
    "searchNoResult": "暂无关于\"{keyword}\"的搜索结果",
    "searchTips": "可以去{store}看看，或用{aiSymbol}",
    "store": "符号社区",
    "aiSymbol": "AI生成符号"
  },
  "en": {
    "title": "My Shapes",
    "close": "Close",
    "searchSymbol": "Search Shapes",
    "collectSymbol": "My Collect",
    "toggleLib": "Hide Library",
    "searchTitle": "History",
    "searchOK": "Search Completed",
    "searchResult": "Search Result",
    "searchIng": "Searching",
    "noResult": "Oops! We couldn't find \"{keyWord}\". Try searching other keywords or go to Shapes Community.",
    "noResultSdk": "Oops! We couldn't find \"{keyWord}\". Try searching other keywords.",
    "symbolCommunity": "Shapes Community",
    "syncSuccess": "Sync to cloud successful",
    "syncFail": "Sync to cloud failed",
    "myCollect": "My symbol library",
    "edrawMaxLib": "EdrawMax",
    "noCollect": "Empty Shapes Collection.",
    "addCollect": "Add",
    "addMoreShape": "More Shapes",
    "expandLib": "Expanded all",
    "foldLib": "Collapse all",
    "editLib": "Edit Shapes Library",
    "addFromPage": "Add to this library",
    "dragHere": "Drag here",
    "groupSymbolsTips": "Whether to combine the selected shapes into a symbol add",
    "addSuccess": "Added successfully",
    "loading": "Loading",
    "loadFail": "Failed to load,",
    "retry": "Please try again",
    "addSearchResultToRender": "Show in sidebar",
    "deleteFromSearchResult": "Unshow in sidebar",
    "tipTitle": "Choose shapes with a %1 to adjust nodes!",
    "tipContent": "After choosing a shape, place your cursor on the %1. Drag the shape by pressing and holding the left mouse button to change the style.",
    "more": "More",
    "addNewLibrary": "Add New Collection",
    "createFail": "Download Error, Please Check the Network",
    "symbol": "Symbol",
    "searchNoResult": "There are currently no search results for\"{keyword}\"",
    "searchTips": "You can visit the {store} Or use {aiSymbol}",
    "store": "Symbol Community",
    "aiSymbol": "AI Symbol"
  },
  "fr": {
    "title": "Symboles",
    "close": "Fermer",
    "searchSymbol": "Rechercher un symbole",
    "collectSymbol": "Ma collection",
    "toggleLib": "Cacher bibliothèque de symboles",
    "searchTitle": "Historique de recherche",
    "searchOK": "Recherche terminée",
    "searchResult": "Résultat de la recherche",
    "searchIng": "Recherche",
    "noResult": "Oups ! Nous n'avons pas pu trouver \"{keyWord}\". Essayez de chercher d'autres mots-clés ou allez à la Communauté des symboles.",
    "symbolCommunity": "Communauté de symboles",
    "syncSuccess": "Sync en nuage avec succès",
    "syncFail": "Sync Cloud échoué",
    "myCollect": "Ma bibliothèque de symboles",
    "edrawMaxLib": "EdrawMax",
    "noCollect": "Collection de symboles vide.",
    "addCollect": "Ajouter",
    "addMoreShape": "Paramétrage de la forme",
    "expandLib": "Tout afficher",
    "foldLib": "Tout réduire",
    "editLib": "Modifier la bibliothèque de symboles",
    "addFromPage": "Ajouter les graphiques sélectionnés à cette bibliothèque",
    "dragHere": "Faites glisser ici",
    "groupSymbolsTips": "Combiner les formes sélectionnées dans une collection de symboles?",
    "addSuccess": "Ajouté avec succès",
    "loading": "Chargement en cours",
    "loadFail": "Échec du chargement,",
    "retry": "Veuillez réessayer",
    "addSearchResultToRender": "Afficher dans la barre latérale",
    "deleteFromSearchResult": "Ne pas afficher",
    "tipTitle": "Choisissez des formes avec un %1 pour ajuster les nœuds !",
    "tipContent": "Après avoir choisi une forme, placez votre curseur sur le %1. Faites glisser la forme en appuyant sur le bouton gauche de la souris et en le maintenant enfoncé pour modifier le style.",
    "more": "Plus",
    "addNewLibrary": "Ajouter une nouvelle collection",
    "createFail": "Echec du téléchargement, veuillez vérifier le réseau",
    "symbol": "Forme",
    "searchNoResult": "Il n&apos;y a actuellement aucun résultat de recherche pour « {keyword} »",
    "searchTips": "Vous pouvez vous rendre sur la{store}, Vous pouvez également utiliser le{aiSymbol}",
    "store": "Communauté symbole",
    "aiSymbol": "Symbole IA"
  },
  "de": {
    "title": "Symbolbibliothek",
    "close": "Abschließen",
    "searchSymbol": "Suchsymbol",
    "collectSymbol": "Meine Sammlung",
    "toggleLib": "Bibliothek ausblenden",
    "searchTitle": "Velauf",
    "searchOK": "Suche abgeschlossen",
    "searchResult": "Suchergebnis",
    "searchIng": "Suche",
    "noResult": "Ups! Wir konnten \"{keyWord}\" nicht finden. Versuchen Sie nach anderen Schlüsselwörtern zu suchen oder gehen Sie zur Shape Community.",
    "symbolCommunity": "Symbolgemeinschaft",
    "syncSuccess": "Synchonisation mit Cloud erfolgreich",
    "syncFail": "Synchronisierung mit Cloud fehlgeschlagen",
    "myCollect": "Meine Symbolbibliothek",
    "edrawMaxLib": "EdrawMax",
    "noCollect": "Leere Symbolsammlung",
    "addCollect": "Hinzufügen",
    "addMoreShape": "Formeinstellung",
    "expandLib": "Alles erweitern",
    "foldLib": "Alles zusammenbrechen",
    "editLib": "Symbolbibliothek bearbeiten",
    "addFromPage": "Zu dieser Bibliothek hinzufügen",
    "dragHere": "Hier ziehen",
    "groupSymbolsTips": "Gibt an, ob die ausgewählten Formen zu einer Symbolsammlung kombiniert werden sollen",
    "addSuccess": "Erfolgreich hinzugefügt",
    "loading": "Beladen ",
    "loadFail": "Laden fehlgeschlagen,",
    "retry": "Bitte versuche es erneut",
    "addSearchResultToRender": "In der Seitenleiste anzeigen",
    "deleteFromSearchResult": "Nicht anzeigen ",
    "tipTitle": "Wählen Sie Formen mit einem %1, um Knoten anzupassen!",
    "tipContent": "Nachdem Sie eine Form ausgewählt haben, setzen Sie den Mauszeiger auf das %1. Ziehen Sie die Form, indem Sie die linke Maustaste gedrückt halten, um den Stil zu ändern.",
    "more": "Mehr",
    "addNewLibrary": "Neue Sammlung hinzufügen",
    "createFail": "Download-Fehler, bitte überprüfen Sie das Netzwerk.",
    "symbol": "Form bearbeiten",
    "searchNoResult": "Derzeit gibt es keine Suchergebnisse für „{keyword}“",
    "searchTips": "Sie können die{store}besuchen, Oder {aiSymbol} verwenden",
    "store": "Symbol-Community",
    "aiSymbol": "AI Symbol"
  },
  "jp": {
    "title": "図形ライブラリ",
    "close": "閉じる",
    "searchSymbol": "図形を検索",
    "collectSymbol": "お気に入り",
    "toggleLib": "図形ライブラリを非表示",
    "searchTitle": "検索履歴",
    "searchOK": "検索完了",
    "searchResult": "検索結果",
    "searchIng": "検索中",
    "noResult": "「{keyWord}」に一致するものは見つかりませんでした。他のキーワードで試すか、テンプレートコミュニティで検索してみてください。",
    "symbolCommunity": "シンボルコミュニティ",
    "syncSuccess": "クラウドに正常に同期しました",
    "syncFail": "クラウドへの同期に失敗しました",
    "myCollect": "私の図形ライブラリ",
    "edrawMaxLib": "Edraw図形ライブラリ",
    "noCollect": "図形なし",
    "addCollect": "追加",
    "addMoreShape": "形状設定",
    "expandLib": "すべて展開",
    "foldLib": "すべて折りたたむ",
    "editLib": "タイトル",
    "addFromPage": "このライブラリに追加する図形を選択",
    "dragHere": "ここにドラッグ＆ドロップ",
    "groupSymbolsTips": "選択した図形をグループ化にするかどうか",
    "addSuccess": "追加されました",
    "loading": "読み込み中",
    "loadFail": "読み込みに失敗しました、",
    "retry": "もう一度やり直してください",
    "addSearchResultToRender": "サイドバーに表示",
    "deleteFromSearchResult": "表示しない ",
    "tipTitle": "図形の %1 を選択してノードを調整！",
    "tipContent": "図形を選択したら、%1 にカーソルを置きます。マウスの左ボタンを押したまま図形をドラッグして、スタイルを変更します。",
    "more": "その他",
    "addNewLibrary": "新規コレクションを追加",
    "createFail": "ダウンロードに失敗しました。ネットワークを確認してください",
    "symbol": "図形",
    "searchNoResult": "現在、「{keyword}」の検索結果はありません",
    "searchTips": "{store}をチェックするか，{aiSymbol}を使用できます",
    "store": "Symbolコミュニティ",
    "aiSymbol": "AI記号"
  },
  "es": {
    "title": "Biblioteca de símbolos",
    "close": "Cerrar",
    "searchSymbol": "Símbolo de búsqueda",
    "collectSymbol": "Mi colección",
    "toggleLib": "Ocultar la biblioteca",
    "searchTitle": "Historia",
    "searchOK": "Búsqueda completada",
    "searchResult": "Resultado de la búsqueda",
    "searchIng": "Buscando en",
    "noResult": "¡Ups! No hemos podido encontrar \"{keyWord}\". Intenta buscar otras palabras clave o ve a la Comunidad de Símbolos.",
    "symbolCommunity": "Símbolo Comunidad",
    "syncSuccess": "Sincronización a la nube exitosa",
    "syncFail": "La sincronización con la nube falló",
    "myCollect": "Mi biblioteca de símbolos",
    "edrawMaxLib": "La biblioteca de símbolos de EdrawMax",
    "noCollect": "Colección de símbolos vacíos",
    "addCollect": "Añade",
    "addMoreShape": "Configuración de forma",
    "expandLib": "Ampliar todo",
    "foldLib": "Desplegar todo",
    "editLib": "Editar biblioteca de símbolos",
    "addFromPage": "Agregar gráficos seleccionados a la biblioteca",
    "dragHere": "Arrastrar y soltar aquí",
    "groupSymbolsTips": "Si combinar las formas seleccionadas en una colección de símbolos",
    "addSuccess": "Agregado exitosamente",
    "loading": "Cargando",
    "loadFail": "Falló al cargar,",
    "retry": "Inténtalo de nuevo",
    "addSearchResultToRender": "Mostrar en la barra lateral",
    "deleteFromSearchResult": "No mostrar ",
    "tipTitle": "Elija formas con %1 para ajustar nodos.",
    "tipContent": "Tras elegir una forma, coloque el cursor en %1. Mantenga pulsado el botón izquierdo del ratón para arrastrar la forma y cambiar el estilo.",
    "more": "Más",
    "addNewLibrary": "Agregar nueva colección",
    "createFail": "Error de descarga, por favor compruebe la red",
    "symbol": "Símbolo",
    "searchNoResult": "Actualmente no hay resultados de búsqueda para \"{keyword}\"",
    "searchTips": "Puedes visitar la {store}, O usar {aiSymbol}",
    "store": "Comunidad de símbolos",
    "aiSymbol": "Símbolos generados por IA"
  },
  "pt": {
    "title": "Biblioteca de Símbolos",
    "close": "Fechar",
    "searchSymbol": "Pesquisar Símbolo",
    "collectSymbol": "Minha Coleção",
    "toggleLib": "Esconder Biblioteca",
    "searchTitle": "Histórico",
    "searchOK": "Pesquisa Completa",
    "searchResult": "Resultado da pesquisa",
    "searchIng": "Pesquisando",
    "noResult": "Ops! Não foi possível encontrar \"{keyWord}\". Por favor, tente procurar outras palavras-chave ou vá à Comunidade de Símbolos.",
    "symbolCommunity": "Comunidade de símbolos",
    "syncSuccess": "Sincronizado para cloud com sucesso",
    "syncFail": "Falha ao sincronizar com cloud",
    "myCollect": "Minha biblioteca de símbolos",
    "edrawMaxLib": "EdrawMax",
    "noCollect": "Coleção de Símbolos Vazia.",
    "addCollect": "Adicionar",
    "addMoreShape": "Configuração de forma",
    "expandLib": "Todos expandidos",
    "foldLib": "Colapsar todos",
    "editLib": "Editar Biblioteca de Símbolos",
    "addFromPage": "Adicionar da Página",
    "dragHere": "Arrastar aqui",
    "groupSymbolsTips": "Dicas de Símbolos de Grupo",
    "addSuccess": "Adicionado com sucesso",
    "loading": "Carregando",
    "loadFail": "Falha ao carregar,",
    "retry": "Por favor, tente novamente",
    "addSearchResultToRender": "Mostrar na barra lateral",
    "deleteFromSearchResult": "Não mostrar",
    "tipTitle": "Escolha formas com um %1 para ajustar os nós!",
    "tipContent": "Depois de escolher uma forma, coloque o cursor no %1. Arraste a forma pressionando e mantendo o botão esquerdo do mouse pressionado para alterar o estilo.",
    "more": "Mais",
    "addNewLibrary": "Adicionar nova coleção",
    "createFail": "Erro ao Descarregar, Por Favor, verificar a rede",
    "symbol": "Símbolo",
    "searchNoResult": "No momento, não há resultados de pesquisa para \"{keyword}\"",
    "searchTips": "Você pode visitar a {store}, Ou usar{aiSymbol}",
    "store": "Comunidade de símbolos",
    "aiSymbol": "Símbolos de IA"
  },
  "it": {
    "title": "Libreria Simboli",
    "close": "Chiudi",
    "searchSymbol": "Cerca Simboli",
    "collectSymbol": "La Mia Raccolta",
    "toggleLib": "Nascondi Libreria",
    "searchTitle": "Cronologia",
    "searchOK": "Ricerca Completata",
    "searchResult": "Risultato della ricerca",
    "searchIng": "Ricerca in Corso",
    "noResult": "Oops! Non possiamo trovare \"{keyWord}\". Prova a cercare altre parole chiave o vai alla Comunità dei Simboli.",
    "symbolCommunity": "Simbolo Comunità",
    "syncSuccess": "Sincronizzazione con il cloud completata con successo.",
    "syncFail": "Sincronizzazione con il cloud fallita.",
    "myCollect": "La mia libreria di simboli",
    "edrawMaxLib": "EdrawMax",
    "noCollect": "Raccolta di Simboli Vuota.",
    "addCollect": "Aggiungi",
    "addMoreShape": "Impostazione della forma",
    "expandLib": "Espandi Tutto",
    "foldLib": "Riduci Tutto",
    "editLib": "Modifica libreria di simboli",
    "addFromPage": "Aggiungi a questa libreria",
    "dragHere": "Trascina qui",
    "groupSymbolsTips": "Se combinare le forme selezionate in una raccolta di simboli",
    "addSuccess": "Aggiunto con successo",
    "loading": "Caricamento in corso",
    "loadFail": "Caricamento fallito,",
    "retry": "Per favore riprova",
    "addSearchResultToRender": "Mostra nella barra laterale",
    "deleteFromSearchResult": "Non mostrare",
    "tipTitle": "Scegli le forme con %1 per regolare i nodi!",
    "tipContent": "Dopo aver scelto una forma, posiziona il cursore su %1. Trascina la forma tenendo premuto il pulsante sinistro del mouse per modificare lo stile.",
    "more": "Altro",
    "addNewLibrary": "Aggiungi nuova collezione",
    "createFail": "Errore di download. Si prega di controllare la connessione di rete.",
    "symbol": "Simboli",
    "searchNoResult": "Attualmente non sono presenti risultati di ricerca per\"{keyword}\"",
    "searchTips": "Vai a {store}, Oppure utilizza {aiSymbol}",
    "store": "Simboli della community",
    "aiSymbol": "Simbolo AI"
    
  },
  "tw": {
    "title": "符號庫",
    "close": "關閉",
    "searchSymbol": "查找符號",
    "collectSymbol": "我的收藏",
    "toggleLib": "隱藏符號庫",
    "searchTitle": "搜尋記錄",
    "searchOK": "搜尋完成",
    "searchResult": "搜尋結果",
    "searchIng": "搜尋中",
    "noResult": "很抱歉，未匹配到您輸入的關鍵詞 \"{keyWord}\"。請嘗試搜索其他關鍵詞，或者去符號社區搜索哦~",
    "symbolCommunity": "符號社區",
    "syncSuccess": "同步至雲端硬碟成功",
    "syncFail": "同步至雲端硬碟失敗",
    "myCollect": "我的符號庫",
    "edrawMaxLib": "億圖圖示符號庫",
    "noCollect": "暫無符號",
    "addCollect": "前往添加",
    "addMoreShape": "形狀設定",
    "expandLib": "全部展開",
    "foldLib": "全部折疊",
    "editLib": "编辑符号库",
    "addFromPage": "選中圖形添加到此庫",
    "dragHere": "拖拽到此處",
    "groupSymbolsTips": "是否將選中形狀組合為一個符號添加",
    "addSuccess": "添加成功",
    "loading": "正在為您加載",
    "loadFail": "加載失敗，",
    "retry": "請重試",
    "addSearchResultToRender": "在側邊欄顯示",
    "deleteFromSearchResult": "不顯示",
    "tipTitle": "選擇具有 %1 的形狀以調整節點！",
    "tipContent": "選擇形狀後，將游標置於 %1 上。按住滑鼠左鍵拖曳該形狀以變更樣式。",
    "more": "更多",
    "addNewLibrary": "新增收藏",
    "createFail": "下載失敗，請檢查網絡"
  },
  "kr": {
    "createFail": "다운로드 오류, 네트워크를 확인하세요"
  }
}
</i18n>
